export default {
    route: {
        dashboard: 'Dashboard',
        article: 'Articles',
    },
    month: {
        jan: 'January',
        feb: 'February',
        mar: 'March',
        apr: 'April',
        may: 'May',
        jun: 'June',
        jul: 'July',
        aug: 'August',
        sep: 'September',
        oct: 'October',
        nov: 'November',
        dec: 'December',
    },
    week: {
        mon: 'mo',
        tue: 'tu',
        wed: 'we',
        thu: 'th',
        fri: 'fr',
        sat: 'sa',
        sun: 'su',
    },
    navbar: {
        logOut: 'Log Out',
        myProfile: 'My Profile',
        termsConditions: 'Terms & Conditions',
    },
    login: {
        title: 'Login : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        logIn: 'Login',
        username: 'Username',
        password: 'Password',
        loginForm: {
            header: 'Welcome to ##COMPANY_BRAND_NAME##',
        },
        qrCode: {
            header: 'Enter the code from your authenticator.',
            subheader: 'Enter the 6 digit code below to continue',
            placeholderSecurityCode: 'Enter Security Code here',
        },
        forgotPassword: {
            header: 'Forgot your password?',
            subheader: 'Enter your email below and we will send a message to reset your password',
            placeholderEmail: 'Enter your email',
        },
        resetPassord: {
            header: 'Reset your password.',
            subheader: 'Please enter the code we emailed you and reset your password.',
            placeholder: {
                code: 'Enter your code',
                newPassWord: 'Enter your new password',
                confirmPassWord: 'Re-Confirm your password',
            },
            success: 'Your password is reset successfully.',
        },
        button: {
            login: 'Login',
            forgotPassword: 'Forgot password?',
            resetMyPassword: 'Reset my password',
            submitMyPassword: 'Save new password',
            back: 'Back',
            instavolt: '##COMPANY_BRAND_NAME##',
        },
        label: {
            rememberMe: 'Remember me',
            password: 'Password',
            userId: 'User ID',
            copyright: 'Copyright ##COMPANY_BRAND_NAME##.',
            showPassword: 'Show Password',
            hidePassword: 'Hide Password',
        },
        errors: {
            email: {
                email: 'Please enter a valid email address.',
                required: 'Please enter your email.',
            },
            password: {
                required: 'Please enter your password.',
                max: 'Password must be at least 8 characters long',
            },
            securityCode: {
                required: 'Please enter your security code.',
                max: 'Security code must be at least 6 characters long',
            },
            verificationCodeInvalid: 'Verification code invalid.',
            generalError: 'Error while processing your request.',
            incorrectCredentials: 'Incorrect username or password.',
            defaultPasswordExpired: 'Your password has expired and must be reset by an administrator.',
            inValidEmailAddress: 'Email address is invalid.',
            securityCodeInvalid: 'Invalid security code.',
            verificationCodeFormat: 'Please enter 6 digit verification code.',
            passwordFormat:
                'Password must be 15+ characters, with at least one uppercase letter, lowercase letter, special character and number.',
            confirmPasswordMatch: 'Password and re-confirm password does not match.',
            common: 'Something went wrong please try again.',
        },
        toast: {
            error: 'Something went wrong please try again.',
        },
    },
    dashboard: {
        title: 'Home : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Dashboard',
        formtitle: 'Form Validation',
        label: {
            pending: 'Pending',
            currentBalance: 'Current Balance',
            closingBalance: 'Closing Balance',
            availableCredit: 'Available Credit',
            unbilledAmount: 'Unbilled Amount',
            filter: 'Filter',
            reportTags: 'Report Tags',
            driverGroup: 'Driver Groups',
            selectDriverGroup: 'Select Driver Groups',
            selectTags: 'Select Tags',
            dateRange: 'Date Range',
            month: 'Month',
            year: 'Year',
            day: 'Day',
            week: 'Week',
            userSessionTitle: 'Driver Sessions',
            userSessions: 'Driver Sessions',
            expenseTitle: 'Sum of Expense',
            expense: 'Expense',
            energyTitle: 'Sum of Energy (kWh)',
            enrgy: 'Energy',
            averageTransationTitle: 'Average Transactions',
            transaction: 'Transaction',
            creditLimit: 'Credit Limit',
            totalDriverAccounts: 'Total Driver Accounts',
            enabled: 'Enabled',
            disabled: 'Disabled',
        },
        button: {
            apply: 'Apply',
            clear: 'Clear',
        },
        cpoType: {
            Both: 'Both',
            Local: 'Local',
            International: 'International',
        },
    },
    permission: {
        createArticle: 'Add Article',
        editArticle: 'Edit Article',
        save: 'Save',
        confirm: 'Are You Sure?',
        cancel: 'Cancel',
        update: 'Update',
    },
    table: {
        pagination: {
            prev: 'Prev',
            nrev: 'Next',
            showing: 'Showing',
        },
        data: {
            noData: 'No Data Found.',
        },
    },
    article: {
        title: 'Manage Article',
        id: 'Article ID',
        date: 'Date',
        tabletitle: 'Title',
        author: 'Author',
        reviewer: 'Reviewer',
        actions: 'Actions',
        saveMessage: 'Article Save Successfully',
        updateMessage: 'Article Updated Successfully',
        deleteMessage: 'Article Deleted Successfully',
    },
    user: {
        title: 'Users : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        user: 'Users',
        manageUser: 'Manage User',
        placeholder: {
            name: 'Name',
            email: 'Email Address',
            phoneNo: 'Phone No.',
            firstName: 'First Name',
            lastName: 'Last Name',
            userGroup: 'User Groups',
            userRoles: 'User Roles',
            Organisation: 'Organisation',
            select: 'Select Status',
            selectOrganisation: 'Select Organisation',
            selectUserGroup: 'Select User Group',
            languagePreference: 'Language Preference',
        },
        label: {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            phoneNo: 'Phone No.',
            optional: '(Optional)',
            userGroups: 'User Groups',
            userRoles: 'User Roles',
            Organisation: 'Organisation',
            createdDate: 'Created Date',
            languagePreference: 'Language Preference',
            id: 'Id',
            action: 'Action',
            status: 'Status',
            name: 'Name',
            delete: 'Delete',
            enable: 'Enable',
            all: 'All',
            disable: 'Disable',
            enabled: 'Enabled',
            disabled: 'Disabled',
            pending: 'Pending',
            reset2FA: 'Reset 2FA',
            deleted: 'Deleted',
            lastLoginDate: 'Last Login Date',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            save: 'Save',
            add: 'Add',
            edit: 'Edit',
            reset: 'Reset',
            delete: 'Delete',
            yes: 'Yes',
            no: 'No',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
            sendEmail: 'Send Email',
            reset2FA: 'Reset 2FA',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            sendMailConfirmMessage: 'Are you sure you want to send email?',
            mailSentSuccessMessage: 'Email sent successfully.',
            reset2FAConfirmMesage: 'Are you sure you want to reset 2FA for this user?',
        },
        errors: {
            email: {
                required: 'Please enter email ddress',
                email: 'Please enter valid email address',
            },
            firstName: {
                required: 'Please enter first name',
                valid: 'Please enter valid first name',
            },
            lastName: {
                required: 'Please enter last name',
                valid: 'Please enter valid last name',
            },
            phoneNo: {
                required: 'Please enter phone number',
                match: 'Please enter valid phone number',
            },
            userGroups: {
                required: 'Please select at least one User Group',
            },
            organization: {
                required: 'Please select organisation',
            },
        },
    },
    userGroup: {
        title: 'User Groups : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        manageUserGroup: 'Manage User Group',
        users: 'Users',
        header: 'User Groups',
        button: {
            search: 'Search',
            reset: 'Reset',
            edit: 'Edit',
            delete: 'Delete',
            save: 'Save',
            cancel: 'Cancel',
            yes: 'Yes',
            no: 'No',
            action: 'Action',
            add: 'Add',
            back: 'Back',
            enable: 'Enable',
            disable: 'Disable',
            permission: 'Access Permission',
        },
        placeholder: {
            groupName: 'Group Name',
            users: 'Select Users',
            select: 'Select Status',
            organisation: 'Select Organisation',
        },
        message: {
            deleteConfirmMesageForOrganistion:
                'Deleting this organisation group, we will remove group association for particular organisation, are you sure you want to continue?',
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
        },
        label: {
            id: 'Id',
            name: 'Name',
            description: 'Description',
            Organisation: 'Organisation',
            createdBy: 'Created By',
            status: 'Status',
            modifiedBy: 'Modified By',
            createdDate: 'Created Date',
            modifiedDate: 'Modified Date',
            action: 'Action',
            groupName: 'Group Name',
            delete: 'Delete',
            enable: 'Enable',
            disable: 'Disable',
            phoneNo: 'Phone Number',
            email: 'Email Address',
            groupAccess: 'Group Access',
            selectUsers: 'Select Users',
            enabled: 'Enabled',
            disabled: 'Disabled',
            yes: 'Yes',
            no: 'No',
        },
        form: {
            groupName: {
                label: 'Group Name',
                placeholder: 'Enter group name',
            },
            description: {
                label: 'Description',
                placeholder: 'Enter description',
            },
            Organisation: {
                label: 'Organisation',
            },
        },
        errors: {
            groupName: {
                required: 'Please enter group name',
                valid: 'Please enter valid group name',
                max: 'Maximum 50 characters allowed',
            },
            description: {
                max: 'Maximum 255 characters allowed',
            },
            userList: {
                required: 'Please select at least one user',
            },
        },
        permission: {
            header: 'Permission',
            label: {
                module: 'Module',
                subModule: 'Sub Module',
                action: 'Action',
            },
        },
    },
    transactions: {
        headerTitle: 'Driver Transactions - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        title: 'Driver Transactions',
        transaction: 'Transaction',
        columns: {
            amount: 'Amount',
            location: 'Location',
            date: 'Date',
            milesAdded: 'Miles Added',
            time: 'Time',
            cost: 'Cost',
            energy: 'Energy',
            action: 'Action',
            remark: 'Remarks',
            credit: 'Credit',
            debit: 'Debit',
            closing: 'Closing',
            transaction: 'Transaction ID',
            name: 'Name',
            type: 'Type',
            federatedAccount: 'Federated Account Type',
            reference_id: 'Reference ID',
            energyCost: 'Energy Cost',
            fixedCost: 'Fixed Cost',
            chargingTimeCost: 'Charging Time Cost',
            parkingTime: 'Parking Time',
            parkingCost: 'Parking Cost',
            appliedTariff: 'Applied Tariff',
            netCost: 'Net Cost',
            VATRate: 'VAT Rate',
        },
        form: {
            charge: 'Charging',
            payment: 'Payment',
            month: 'Month',
        },
        label: {
            exportAll: 'Export All',
            driver: 'Driver',
            vehicle: 'Vehicle',
            cardPayment: 'Card Payment',
            referralBonus: 'Referral Bonus',
            rewards: 'Rewards',
            transactionDetails: 'Transaction Details',
            transaction_id: 'Transaction Id',
            fullName: 'Full Name',
            email: 'Email',
            phone_number: 'Phone Number',
            viewFailedPayments: 'View Failed Payments',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            back: 'Back',
        },
        placeholder: {
            startDate: 'Start Date',
            endDate: 'End Date',
            name: 'Name',
            chargingStation: 'Charging Station',
            selectType: 'Select Type',
            transaction: 'Transaction ID',
            reference_id: 'Reference ID',
        },
        message: {
            noDataToExport: 'There is no data to export.',
            error: {
                common: 'Something went wrong. Please try again',
            },
        },
    },
    driver: {
        title: 'Drivers : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Drivers',
        manageDriver: 'Manage Driver',
        startCharge: 'Start Remote Charge',
        activities: 'Activities',
        detail: 'Driver Details',
        address_detail: 'Address',
        billing_address_detail: 'Billing Address',
        chargeDetails: 'Charging Details',
        debtLetterHistory: 'Debt Letter History',
        note: "Note: If driver's existing reward is different than new promotion then his current volts will be lapsed.",
        charityAdded: 'Charity Donation Added',
        cd: 'cd',
        placeholder: {
            name: 'Name',
            email: 'Email Address',
            firstName: 'First Name',
            lastName: 'Last Name',
            payment_card: 'Last 4 Digits of Payment Card',
            select: {
                status: 'Select Status',
                account_type: 'Select account type',
                payment_type: 'Select payment type',
                driver_groups: 'Select driver groups',
                driver_tags: 'Select tags',
                organization: 'Select organisation',
                promotion: 'Select promotion',
            },
            driverGroup: 'Driver Groups',
            organization: 'Organisation',
            account_type: 'Account Type',
            payment_type: 'Payment Type',
            referral_code: 'Referral Code',
            driver_tags: 'Tags',
            address: 'Address line 1',
            address2: 'Address line 2',
            city: 'City',
            county: 'County',
            postal_code: 'Postal Code',
            billing_address: 'Address line 1',
            billing_address2: 'Address line 2',
            billing_city: 'City',
            billing_county: 'County',
            billing_postal_code: 'Postal Code',
            promotion: 'Promotions',
            currentDriverPromotion: 'Current Promotion',
            driverPromotionJoinDate: 'Joined date',
            chargeLocation: 'Location',
            chargeStation: 'Station',
            connector: 'Connector',
            limitedKWH: 'Limited kWh:',
            confirmationNote:
                "For account security, please confirm the individual driver's first name, last name, address line 1 and postcode before starting remote charge. Please tick the box after customer's confirmation",
            rfidCard: 'RFID Card',
            confirmationNoteFleet: 'Please confirm this password with driver: ',
            vehicle_number: 'Vehicle Number',
            api_url: 'API URL',
            startDate: 'Start Date',
            endDate: 'End Date',
            publicRFID: 'Public RFID Card ID',
            languagePreference: 'Language Preference',
            searchAddress: 'Address',
        },
        label: {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            group: 'Group',
            driverGroups: 'Driver Groups',
            driver_tags: 'Tags',
            organization: 'Organisation',
            payment_type: 'Payment Type',
            referral_code: 'Referral Code',
            createdDate: 'Created Date',
            id: 'Id',
            action: 'Action',
            status: 'Status',
            account_type: 'Account Type',
            type: 'Type',
            name: 'Name',
            delete: 'Delete',
            enable: 'Enable',
            all: 'All',
            disable: 'Disable',
            enabled: 'Enabled',
            disabled: 'Disabled',
            cancelled: 'Cancelled',
            deleted: 'Deleted',
            address: 'Address',
            address2: 'Address line 2',
            city: 'City',
            county: 'County',
            postal_code: 'Postal Code',
            billing_address: 'Address line 1',
            billing_address2: 'Address line 2',
            billing_city: 'City',
            billing_county: 'County',
            billing_postal_code: 'Postal Code',
            promotion: 'Promotions',
            expired: ' - Expired',
            currentDriverPromotion: 'Current Promotion',
            driverPromotionJoinDate: 'Joined date',
            vehicleNumber: 'Vehicle Number',
            paymentCard: 'Payment Card',
            cardType: 'Card Type',
            cardNumber: 'Card No. (Last 4 digits)',
            cardTitle: 'Card Title',
            cardExpiry: 'Card Expiry Date',
            paymentServiceProvider: 'Payment Service Provider',
            viewReferral: 'View Referral',
            referralDetails: 'Referral Details',
            referrer_name: 'Referrer Name',
            referral_name: 'Referral Name',
            referral_bonus: 'Referral Bonus',
            referralBonusStatus: 'Referral Bonus Status',
            referee_Name: 'Referee Name',
            noRecords: 'No records to display',
            noReferralsMessage: 'No Referral(s)',
            referrerName: "Referee's Referrer Name: ",
            referralCode: "Referrer's Referral Code:",
            noReferrerMessage: 'No Referrer',
            current_balance: 'Current Balance',
            referral_balance: 'Referral Balance',
            account_balance: 'Account Balance',
            rewards_balance: 'Rewards Balance',
            balanceDetails: 'Balance Details',
            pending_transactions_details: 'Pending Transactions Details',
            pending_balance: 'Pending Balance',
            federated_account_type: 'Federated Account Type',
            pending: 'Pending',
            rfidCard: 'RFID Card',
            startCharge: 'Start Remote Charge',
            chargeLocation: 'Location',
            chargeStation: 'Station',
            connector: 'Connector',
            limitedKWH: 'Limited kWh:',
            confirmationNote:
                "For account security, please confirm the individual driver's first name, last name, address line 1 and postcode before starting remote charge. Please tick the box after customer's confirmation",
            fullName: 'Full Name',
            phoneNo: 'Phone Number',
            confirmationNoteFleet: 'Please confirm this password with driver: ',
            chargingStartedMessage: 'Start remote charge request raised successfully',
            resetPassword: 'Reset Password',
            password: 'Password',
            disablePaymentCard: 'Disable Payment Card',
            requestedData: 'Requested Data',
            apiURL: 'API',
            viewData: 'View Data',
            deletionEmailSent: 'Account Deletion Email Sent',
            yes: 'Yes',
            onstop: 'On Stop',
            badDebtor: 'Bad Debtor',
            available: 'Available',
            languagePreference: 'Language Preference',
            fakeAccount: 'Fake Account',
            addNotes: 'Add Notes',
            newNote: 'New Note',
            addNote: 'Add Note',
            existingNotes: 'Existing Notes',
            viewNotes: 'View Notes',
            notes: 'Notes',
            financialDetails: 'Financial Details',
            letterID: 'Letter ID',
            dateGenerated: 'Date Generated',
            debtValue: 'Debt Value',
            letterTemplate: 'Letter Template Used',
            lastCardValidationDate: 'Last Card validation Date',
            cancelPendingTransactions: 'Cancel Pending Transactions',
            cancelTransactions: 'Cancel Transactions',
        },
        pendingTransaction: {
            label: {
                chargeLocation: 'Location',
                chargeStation: 'Charge Station',
                sessionId: 'Session Id',
                sessionStatus: 'Session Status',
                amount: 'Amount',
                createdDate: 'Created Date',
            },
            button: {
                settle: 'Settle',
                cancel: 'Cancel',
            },
        },
        account_type: {
            driver: 'Driver',
            vehicle: 'Vehicle',
        },
        payment_type: {
            credit_account: 'Credit Account',
            prepayment_account: 'Prepayment Account',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            save: 'Save',
            edit: 'Edit',
            reset: 'Reset',
            delete: 'Delete',
            yes: 'Yes',
            no: 'No',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
            sendEmail: 'Send Email',
            viewTransactions: 'View Transactions',
            close: 'Close',
            startCharge: 'Start Remote Charge',
            startChargeBtn: 'Start Charge',
            resetPassword: 'Reset Password',
            submit: 'Submit',
            amendBalance: 'Amend Balance',
            viewActivities: 'View Activities',
            premiumSubscriptions: 'Premium Subscriptions',
            markAsFake: 'Mark as Fake Account',
            addNotes: 'Add Notes',
            debtLetterHistory: 'Debt Letter History',
            enableReferralCode: 'Enable Referral Code',
            disableReferralCode: 'Disable Referral Code',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            sendMailConfirmMessage: 'Are you sure you want to send email?',
            mailSentSuccessMessage: 'Email sent successfully.',
            resetPasswordConfirmMesage: 'Are you sure you want to reset password for this user?',
            deleteDriverConfirmMesage: "Are you sure you want to delete this driver's account?",
            markAsFakeConfirmMessage:
                'Do you want to mark this driver account as fake, This is a one way process where information is cleared.',
            enableReferralCodeConfirmMesage: 'Are you sure you want to enable Referral Code for this driver?',
            disableReferralCodeConfirmMesage: 'Are you sure you want to disable Referral Code for this driver?',
            cancelPendingTransactionsConfirmMesage:
                'Are you sure you want to cancel the selected pending transactions?',
        },
        errors: {
            driverGroups: {
                required: 'Please select at least one Driver Group',
            },
            organization: {
                required: 'Please select organisation',
            },
            tag: {
                invalid_fromat: 'Invalid characters in Tag',
            },
            fullName: {
                valid: 'Please enter valid name',
            },
            phoneNo: {
                match: 'Please enter valid phone number',
            },
            email: {
                required: 'Please enter email ddress',
                email: 'Please enter valid email address',
            },
            password: {
                passwordFormat:
                    'Password must be 10+ characters, with at least one uppercase letter, lowercase letter, special character and number.',
            },
        },
    },
    driverGroup: {
        title: 'Driver Groups : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        titleFleet: 'Groups : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        manageDriverGroup: 'Manage Driver Group',
        manageDriverGroupFleet: 'Manage Group',
        driversList: 'Drivers',
        driversListFleet: 'Drivers/Vehicles',
        header: 'Driver Groups',
        headerFleet: 'Groups',
        button: {
            search: 'Search',
            reset: 'Reset',
            edit: 'Edit',
            delete: 'Delete',
            save: 'Save',
            cancel: 'Cancel',
            yes: 'Yes',
            no: 'No',
            action: 'Action',
            add: 'Add',
            back: 'Back',
            enable: 'Enable',
            disable: 'Disable',
        },
        placeholder: {
            groupName: 'Group Name',
            drivers: 'Select Drivers',
            driversFleet: 'Select Drivers/Vehicles',
            select: 'Select Status',
            selectType: 'Select Type',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
        },
        label: {
            id: 'Id',
            name: 'Name',
            description: 'Description',
            organization: 'Organisation',
            createdBy: 'Created By',
            status: 'Status',
            modifiedBy: 'Modified By',
            createdDate: 'Created Date',
            modifiedDate: 'Modified Date',
            action: 'Action',
            groupName: 'Group Name',
            delete: 'Delete',
            enable: 'Enable',
            disable: 'Disable',
            phoneNo: 'Phone Number',
            email: 'Email Address',
            groupAccess: 'Group Access',
            selectDrivers: 'Select Drivers',
            selectDriversFleet: 'Select Drivers/Vehicles',
            enabled: 'Enabled',
            disabled: 'Disabled',
            yes: 'Yes',
            no: 'No',
            vehicle_number: 'Vehicle No',
            type: 'Type',
            updateDriverAssociation: 'Update Driver Association',
            addToThisGroup: 'Add To This Group',
            cancel: 'Cancel',
        },
        form: {
            groupName: {
                label: 'Group Name',
                placeholder: 'Enter group name',
            },
            description: {
                label: 'Description',
                placeholder: 'Enter description',
            },
        },
        errors: {
            groupName: {
                required: 'Please enter group name',
                valid: 'Please enter valid group name',
                max: 'Maximum 50 characters allowed',
            },
            description: {
                max: 'Maximum 255 characters allowed',
            },
            driverList: {
                required: 'Please select at least one driver',
                requiredfleet: 'Please select at least one driver/vehicle',
            },
            spendLimit: {
                valid: 'Please enter atleast one spend limit value',
            },
        },
    },
    vat: {
        title: 'VAT : ##COMPANY_BRAND_NAME##',
        vat: 'VAT',
        manageVat: 'Manage VAT',
        label: {
            name: 'Name',
            description: 'Description',
            rate: 'Rate',
            createdDate: 'Created Date',
            action: 'Action',
            status: 'Status',
            disabled: 'Disabled',
            enabled: 'Enabled',
            delete: 'Delete',
            enable: 'Enable',
            disable: 'Disable',
            defaultVAT: 'Default VAT',
            yes: 'Yes',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            setDefaultConfirmMesage: 'Are you sure you want to set this VAT as default?',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            save: 'Save',
            add: 'Add',
            edit: 'Edit',
            reset: 'Reset',
            delete: 'Delete',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
            setDefaultVAT: 'set as Default',
        },
        placeholder: {
            select: 'Select Status',
            name: 'Name',
            description: 'Description',
            rate: 'Rate',
        },
        errors: {
            name: {
                valid: 'Enter valid name.',
            },
            rate: {
                max: 'Rate can not be greater than 100',
                min: 'Rate can not be less than 0',
                number: 'Rate must be a number',
            },
            description: {
                valid: 'Enter valid description',
            },
        },
    },
    confirmBox: {
        button: {
            yes: 'Yes',
            no: 'No',
            proceed: 'Proceed',
            cancel: 'Cancel',
        },
    },
    tag: {
        title: 'Tags : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        tag: 'Tags',
        manageUser: 'Manage Users',
        placeholder: {
            name: 'Tag Name',
            select: 'Select',
        },
        label: {
            name: 'Tag Name',
            driver_count: `Driver Count`,
            charge_location_count: 'Charge Location Count',
            action: 'Action',
            delete: 'Delete',
            editHeader: 'Edit Tag',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            save: 'Save',
            add: 'Add',
            edit: 'Edit',
            reset: 'Reset',
            delete: 'Delete',
            yes: 'Yes',
            no: 'No',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
        },
        message: {
            deleteConfirmMesage:
                'Tag will be deleted from all associated drivers and charge location. Are you sure you want to delete?',
        },
        errors: {
            name: 'Invalid characters in tag',
        },
    },
    chargeStation: {
        title: 'Charge Stations : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        chargeStations: 'Charge Stations',
        manageVat: 'Manage Charge Station',
        label: {
            modifiedDate: 'Modified Date',
            importChargeStationHeader: 'Import Charge station',
            csvFile: 'CSV File',
            manageAmenities: 'Manage Amenities',
            chargePoint: 'Charge Point',
            allLocations: 'All Locations',
            assignedLocation: 'Assigned Locations',
            unassignedLocation: 'Unassigned Locations',
            chargeLocation: {
                cp_id: 'CP-Id',
                type: 'Type',
                name: 'Name',
                locationName: 'Location Name',
                address: 'Address',
                city: 'City',
                postal_code: 'Post Code',
                appliesToOrg: 'Applies to Organisation',
                associatedPromotion: 'Associated Promotion',
                gmbLocationId: 'GMB Location ID',
                override_tariff: 'Override Tariff',
                cpo: 'CPO',
            },
            chargeStation: {
                uid: 'UId',
                evse_id: 'EVSE ID',
                status: 'Status',
                physicalReference: 'Physical Reference',
                city: 'City',
                postal_code: 'PostCode',
            },
            stationConnector: {
                connector_id: 'Connector Id',
                standard: 'Standard',
                format: 'Format as Type',
                power_type: 'Power Type',
                voltage: 'Voltage',
                amperage: 'Amperage',
                power_rating: 'Power Rating',
                override_tariff: 'Override Tariff',
            },
            selectTag: 'Select Tags',
            addTagHeader: 'Associate Tags',
            tags: 'Tags',
            yes: 'Yes',
            assignedTariff: 'Assign Tariff',
            assignTariff: 'Assign Tariff to Locations',
            delete: 'Delete',
            action: 'Action',
            addPromotion: 'Add Promotion',
            selectPromotion: 'Select Promotion',
            exportChargeStations: {
                connector_id: 'connector_id',
                max_power: 'max_power',
                cp_id: 'cp_id',
                type: 'type',
                location: 'location',
                station_name: 'station_name',
                address: 'address',
                city: 'city',
                postal_code: 'postal_code',
                country: 'country',
                latitude: 'latitude',
                longitude: 'longitude',
                evse_id: 'evse_id',
                standard: 'standard',
                format: 'format',
                powertype: 'powertype',
                voltage: 'voltage',
                amperage: 'amperage',
            },
            gmbLocationID: 'GMB Location ID',
            clickHere: 'Click here',
            downloadTemplate: 'to download template',
            importStationsModel: 'Import Charge Stations Model',
            noDataToExport: 'There is no data to export.',
            note: 'Note: ',
            autoCalculateMaxPowerNote:
                'Some CPOs have been configurated to auto calculate max power, by using this import could over write those calculated values.',
            applyToOrg: 'Apply to all Organisation',
        },
        errors: {
            tag: {
                invalid_fromat: 'Invalid characters in Tag',
            },
            file: {
                fileType: "File with extension '.csv' can be uploaded.",
            },
            gmbLocationId: { valid: 'Enter Valid GMB Location ID' },
            common: 'Something went wrong. Please try again',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            save: 'Save',
            cancel: 'Cancel',
            edit: 'Edit',
            expand: 'Expand',
            collapse: 'Collapse',
            import: 'Import',
            synchronize: 'Synchronize',
            syncStation: 'Synchronize Station',
            assignTariff: 'Assign Tariff',
            delete: 'Delete',
            add: 'Add',
            addSelected: 'Add Selected',
            addAll: 'Add All',
            yes: 'Yes',
            no: 'No',
            back: 'Back',
            apply: 'Apply',
            editGMBLocationID: 'Edit GMB Location ID',
            downloadLocationsData: 'Extract Charge Locations Data',
            exportAll: 'Export All',
            importStationsModel: 'Import Charge Stations Model',
            deleteSelected: 'Delete Selected',
            export: 'Export',
            viewAssociatedTariffs: 'View Associated Tariffs',
        },
        placeholder: {
            selectStationStatus: 'Select Status',
            name: 'Name',
            cp_id: 'CP-Id',
            tags: 'Tags',
            address: 'Address',
            selectTag: 'Select Tag',
            evse_id: 'EVSE ID',
            selectChargePoint: 'Select CPOs',
            selectRegion: 'Select Region',
            selectPromotion: 'Select Promotion',
            gmbLocationID: 'GMB Location ID',
            selectPowerType: 'Select Power Type',
            selectAppliedTariff: 'Select Applied Tariff',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            addPromotion: 'Promotion details updated successfully',
            updateAmenitiesSuccess: 'Charge location amenities updated successfully',
            chargePointRequire: 'At least one charge point is required',
            deleteBulkConfirmMessage: 'Are you sure you want to delete selected records?',
            applyToAllOrgConfirmMessage:
                'Would you like to apply this tariff to organisations as well for all locations? ',
        },
        manageAmenities: 'Manage Amenities',
        chargeStationTariffDetailsModal: {
            header: 'Tariff Details',
            tabsName: {
                general: 'General',
            },
        },
    },
    chargeStationMap: {
        title: 'Charge Stations Map View : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Charge Stations',
        label: {
            address: 'Address',
            backOfficeUrl: 'Back Office URL :',
            amenities: 'Amenities :',
            satellite: 'Satellite',
            map: 'Map',
            search: 'Search',
            refresh: 'Refresh',
            apply: 'Apply',
            clear: 'Clear',
            loading: 'Loading...',
        },
        placeholder: {
            locationSearch: 'Search Station',
            mapSearch: 'Search by street name, city or post code',
        },
    },
    promotionsRequest: {
        headerTitle: 'Driver Promotions Request - ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        title: 'Driver Promotions Request',
        promotionsRequest: 'Requested Promotions',
        columns: {
            driverName: 'Driver Name',
            promotionsName: 'Promotions Name',
            promotionsCode: 'Code',
            approved: 'Status',
            approvedBy: 'Modified By',
            approvedDate: 'Modified Date',
            action: 'Action',
            email: 'Email',
        },
        form: {
            charge: 'Charging',
            payment: 'Payment',
            month: 'Month',
        },
        label: {
            approved: 'Approved',
            pending: 'Pending',
            rejected: 'Rejected',
            modelHeader: 'Requested Promotion - ',
            enterComment: 'Enter your comments',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            back: 'Back',
            approved: 'Approve',
            pending: 'Pending',
            rejected: 'Reject',
            action: 'Action',
            edit: 'Edit',
        },
        placeholder: {
            driverName: 'Driver Name',
            promotionsName: 'Promotions Name',
            promotionsCode: 'Code',
            select: 'Select Status',
        },
        message: {
            ManagestatusMesage:
                'Click Approved or Rejected to apply request status.Once this request is updated, it can no longer be edited.',
        },
    },
    driverAccountBalance: {
        title: 'Driver Account Balance : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        driverAccountBalance: 'Driver Account Balance',
        manageUser: 'Manage Driver Account Balance',
        placeholder: {
            name: 'Name/Email',
            select: 'Select Status',
            payment_type: 'Select payment type',
            description: 'Comment',
            amount: 'Enter the Amount to Credit/Debit',
        },
        label: {
            name: 'Name',
            email: `Email`,
            payment_type: 'Payment Type',
            driver_status: 'Account Status',
            current_balance: 'Balance',
            currency: 'Currency',
            driver_id: 'Driver Id',
            action: 'Action',
            delete: 'Delete',
            refundHeader: 'Withdrawal',
            creditPayment: 'Credit Account',
            prePayment: 'Prepayment Account',
            enabled: 'Enabled',
            disabled: 'Disabled',
            refund: 'Amend account balance',
            description: 'Comment',
            amount: 'Enter the Amount to Credit/Debit',
            additional_payment: 'Additional Payment',
            payment_refunds: 'Payment Withdrawals',
            payment_settlement: 'Balance Amendment - Request',
            balance: 'Balance Type',
            accountBalance: 'Account Funds',
            referralBonus: 'Referral Bonus',
            rewardBalance: 'Reward Balance',
            total_balance: 'Total Balance',
            rewards: 'Rewards',
            pendingBalance: 'Pending Balance',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            save: 'Save',
            add: 'Add',
            edit: 'Edit',
            reset: 'Reset',
            delete: 'Delete',
            yes: 'Yes',
            no: 'No',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
            send_for_approval: 'Send for Approval',
        },
        message: {
            deleteConfirmMesage:
                'Tag will be deleted from all associated drivers and charge location. Are you sure you want to delete?',
        },
        errors: {
            name: 'Invalid characters in tag',
            amount: {
                moreThan: 'Amount must be greater/less than 0',
                maxcredit: 'Max limit reached for account credit',
                maxdebit: 'Max limit reached for account debit',
            },
        },
    },
    driverPromotions: {
        title: 'Manage Promotion : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        manageDriverPromotion: 'Manage Promotion',
        driverPromotions: 'Promotions',
        label: {
            name: 'Name',
            code: 'Code',
            errorMessage: 'Error Message',
            used: 'Used',
            unUsed: 'Unused',
            uploadFileErrorMessage: 'Errors while uploading promotion codes.',
            updatePromotionCode: 'Update Promotion Code',
            unique_code: 'Unique Code',
            uniquePromotionCode: 'Promotion Codes',
            importDriverPromotionCodeHeader: 'Import Driver Promotion Code',
            csvFile: 'Promotion Codes',
            promotionCode: 'Promotion Code',
            usedBy: 'Used By',
            description: 'Description',
            accountCredit: 'Account Credit',
            discountRatePeriod: 'Discount Rate Period',
            indays: '(Days)',
            intilakWhRate: 'Initial kWh rate',
            ivRewardsPromotion: 'IV Rewards Promotion',
            referralPromotion: 'Referral Promotion',
            expiryDate: 'Expiry Date',
            needApprovalToJoinPromotion: 'Need approval to join promotion',
            newDriversOnly: 'New drivers only',
            forOrganisation: 'For Organisation',
            createdDate: 'Created Date',
            action: 'Action',
            status: 'Status',
            delete: 'Delete',
            enable: 'Enable',
            disable: 'Disable',
            enabled: 'Enabled',
            disabled: 'Disabled',
            deleted: ' (Deleted)',
            csvFileSupported: 'Only CSV file supported',
            clickHere: 'Click here',
            downloadTemplate: 'to download template',
            exportColumnHeder: 'promotion_codes',
            min_kwh_package_promotion: 'Minimum kWh',
            package_promotion_period: 'Package promotion period (Days)',
            package_promotion_volt_bonus: 'Number of Volts Rewarded',
            rfidCardUnitPrice: 'RFID Card Unit Price',
            subscription: 'Premium Subscription',
            tariffUpdate: 'Tariff Update',
            currentTariff: 'Current Override Tariff',
            next: 'Next',
            newTariff: 'New Override Tariff',
            save: 'Save',
            override_tariff: 'Override Tariff',
            manageOverrideTariff: 'Manage Override Tariff',
        },
        placeholder: {
            name: 'Name',
            promotionCode: 'Promotion Code',
            selectTariff: 'Select Tariff',
            selectStatus: 'Select Status',
            startDate: 'Start Date',
            endDate: 'End Date',
            forOrganisation: 'For Organisation',
            min_kwh_package_promotion: 'Minimum kWh',
            package_promotion_period: 'Package Promotion Period',
            package_promotion_volt_bonus: 'Number of Volts Rewarded',
            rfidCardUnitPrice: 'RFID Card Unit Price',
            premium_subscription: 'Premium Subscription',
            selectCurrentTariff: 'Select Current Override Tariff',
            selectNewTariff: 'Select New Override Tariff',
            selectOverrideTariff: 'Select Override Tariff',
        },
        button: {
            update: 'Update',
            import: 'Import',
            search: 'Search',
            cancel: 'Cancel',
            save: 'Save',
            add: 'Add',
            edit: 'Edit',
            reset: 'Reset',
            delete: 'Delete',
            enable: 'Enable',
            disable: 'Disable',
            action: 'Action',
            back: 'Back',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            subscriptionChangeWarningMessage:
                'Warning: Changing the Subscription Type will result in the cancellation of all the associated Driver account auto-renewals.',
            tariffUpdateNote: 'New Tariff will be assigned to following promotions:',
            updateTariffConfirmMessage: 'Are you sure you want to update tariff for selected promotions?',
            selectOneRecord: 'Please select at least one promotion for tariff update',
        },
        errors: {
            promotionName: {
                valid: 'Enter valid promotion name',
            },
            promotionCode: {
                valid: 'Enter valid promotion code',
            },
            accountCredit: {
                moreThan: 'Account Credit must be greater than 0',
                max: 'Max limit reached for account credit',
                typeError: 'Enter valid accound credit amount',
            },
            discountRatePeriod: {
                moreThan: 'Discount Rate Period must be greater than 0',
            },
            intialRate: {
                max: 'Rate can not be greater than 100',
                min: 'Rate can not be less than 0',
                typeError: 'Enter valid rate',
            },
            common: 'Something went wrong please try again.',
            file: {
                fileType: "File with extension '.csv' can be uploaded.",
            },
            maxValue: 'Maximum value must not exceed 2147483647',
            rfidCardUnitPrice: {
                max: 'RFID Card Unit Price can not be greater than 1000',
            },
        },
    },
    paymentApproval: {
        headerTitle: 'Account Balance Approvals - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        title: 'Account Balance Approvals',
        transaction: 'Transaction',
        columns: {
            email: 'Email',
            amount: 'Amount',
            status: 'Status',
            request_by: 'Requested By',
            request_date: 'Requested On',
            request_by_comment: 'Requested By Comments',
            review_by: 'Reviewed By',
            review_date: 'Reviewed On',
            review_comment: 'Reviewer Comments',
            credit: 'Credit',
            debit: 'Debit',
            closing: 'Closing',
            transaction: 'Transaction ID',
            name: 'Name',
            action: 'Action',
            request_type: 'Request Type',
            invoice: 'Invoice',
        },
        form: {
            driver: 'Driver',
            organisation: 'Organisation',
            month: 'Month',
        },
        label: {
            request_type: 'Request Type',
            refundHeader: 'Balance Amendment',
            pending: 'Pending',
            approved: 'Approve',
            declined: 'Decline',
            approve: 'Approve',
            decline: 'Decline',
            comment: 'Enter your comments',
            status: 'Status',
            refund: 'Approve Credit/Debit',
            refundAmount: 'Withdrawal Amount ',
            commentsFrom: 'Comments from',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
        },
        placeholder: {
            comment: 'Enter your comments',
            status: 'Select Status',
            name: 'Name/Email',
            refundAmount: 'Withdrawal Amount ',
        },
        message: {
            noDataToExport: 'There is no data to export.',
            selectApprovalOrReject: 'Please Approve/Decline this request.',
        },
    },
    paymentScheduleSetting: {
        title: 'Payment Schedule Setting : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Payment Schedule',
        note: ' Schedule a Background job to clear outstanding bills for EV charging performed by Drivers.',
        placeholder: {
            day_of_week: 'Day Of Week',
        },
        label: {
            daily: 'Daily',
            weekly: 'Weekly',
            day_of_week: 'Day of Week',
            selectDay: 'Select Day',
        },
        day_of_week: {
            monday: 'MONDAY',
            tuesday: 'TUESDAY',
            wednesday: 'WEDNESDAY',
            thursday: 'THURSDAY',
            friday: 'FRIDAY',
            saturday: 'SATURDAY',
            sunday: 'SUNDAY',
        },
        button: {
            save: 'Save',
        },
    },
    paymentFailures: {
        title: 'Payment Failures : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        managePaymentFailures: 'Payment Failures',
        placeholder: {
            name: 'Name/Email',
            note: 'Remark',
            startDate: 'Start Date',
            endDate: 'End Date',
            select: 'Select Status',
            status: 'Select status',
            failureReason: 'Failure Reason',
        },
        label: {
            name: 'Name',
            email: `Email`,
            transaction_id: 'Transaction ID',
            total_amount: 'Total Amount',
            currency_name: 'Currency',
            created_date: 'Created Date',
            status: 'Status',
            note: 'Remark',
            action: 'Action',
            editHeader: 'Update Payment Status',
            pending: 'Pending',
            acknowledged: 'Acknowledged',
            closed: 'Closed',
            transactionDetails: 'Transaction Details',
            transaction_request: 'Transaction Request',
            transaction_response: 'Transaction Response',
            error_message: 'Error Message',
            error_code: 'Error Code',
            request_type: 'Request Type',
            response_code: 'Response Code',
            response_code_description: 'Response Code Description',
            null_data: 'No Data Found',
            transaction_date: 'Transaction Date',
            failureReason: 'Failure Reason',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            save: 'Save',
            add: 'Add',
            edit: 'Edit Status',
            reset: 'Reset',
            yes: 'Yes',
            no: 'No',
            action: 'Action',
            back: 'Back',
        },
    },
    chargeTariff: {
        title: 'Tariffs: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Tariffs',
        tariff: 'Tariff',
        columns: {
            location: 'Location',
            chargeStation: 'Charge Station Name',
            connector: 'Connector',
            standard: 'Standard',
        },
        label: {
            name: 'Name',
            vat_name: 'VAT Name',
            vat_rate: 'Rate (%)',
            vat_description: 'Description',
            cpo_id: 'cpo Id',
            action: 'Action',
            url: 'URL',
            currency: 'Currency',
            createdDate: 'Created Date',
            status: 'Status',
            enabled: 'Enabled',
            deleted: 'Deleted',
            detail: 'Detail',
            promotions: 'Promotions',
            lastUpdated: 'Last updated on',
            promotionCode: 'Promotion Code',
            description: 'Description',
            expiryDate: 'Expiry Date',
            priceComponents: 'Price Components',
            priceComponent: 'Price Component',
            type: 'TYPE',
            price: 'PRICE',
            pricePerHour: 'Price (per hour)',
            restriction: 'Restriction',
            startDate: 'Start Date',
            startTime: 'Start Time',
            endDate: 'End Date',
            endTime: 'End Time',
            minkWh: 'Min kWh',
            maxkWh: 'Max kWh',
            minPower: 'Min Power',
            maxPower: 'Max Power',
            minDuration: 'Min Duration',
            maxDuration: 'Max Duration',
            weekDays: 'Week Days',
            selectVat: 'Select VAT',
            attachVat: 'Attach VAT',
            vatdetail: 'VAT Detail',
            editVAT: 'Edit VAT Type',
            vatType: 'VAT Type',
            tariffID: 'Tariff ID',
            element: 'ELEMENT',
            prices: 'Prices',
            restrictions: 'Restrictions',
            stepSize: 'STEP SIZE',
            vat: 'VAT',
            date: 'DATE',
            time: 'TIME',
            kwh: 'KWH',
            power: 'POWER (KW)',
            duration: 'DURATION (SEC)',
            current: 'CURRENT (AMP)',
            maxCurrent: 'Max Current',
            minCurrent: 'Min Current',
            restrictionTitle: 'RESTRICTION',
            details: 'Details',
            weekDaysTitle: 'WEEK DAYS',
            maxKwhTitle: 'Max KWH',
            minKwhTitle: 'Min KWH',
            accessGroups: 'Access Groups',
            locations: 'Locations',
            CPOs: 'CPOs',
            connectors: 'Connectors',
        },
        placeholder: {
            name: 'Name',
            selectStatus: 'Select Status',
            selectVat: 'Select VAT',
            selectType: 'Select VAT Type',
            tariffID: 'Tariff ID',
            vatType: 'VAT Type',
            currency: 'Currency',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            action: 'Action',
            edit: 'Edit',
            detail: 'Detail',
            add: 'Add',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            editvat: 'Attach VAT',
            editVAT: 'Edit VAT Type',
            groupRestrictions: 'Group Tariff Restrictions',
            ungroupRestrictions: 'Ungroup Tariff Restrictions',
        },
        noRestrictionAvailable: 'No Restriction Available',
    },
    partnerPromotion: {
        title: 'Partner Promotions : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Partner Promotions',
        placeholder: {
            nameorcompany: 'Name or Company',
            status: 'Select Status',
            date_from: 'Start Date',
            date_to: 'End Date',
        },
        label: {
            name: 'Name',
            company: 'Company',
            description: 'Description',
            date_from: 'Start Date',
            date_to: 'End Date',
            expiry_date: 'Expiry Date',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
            enabled: 'Enabled',
            disabled: 'Disabled',
            delete: 'Delete',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            add: 'Add',
            save: 'Save',
            edit: 'Edit',
            reset: 'Reset',
            delete: 'Delete',
            yes: 'Yes',
            no: 'No',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
            enable: 'Enable',
            disable: 'Disable',
            chargeStation: 'Charge Stations',
            preview: 'Preview',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
        },
        insert: {
            header: 'Manage Partner Promotions',
            placeholder: {
                name: 'Name',
                company: 'Company Information',
                description: 'Description',
                start_date: 'Start Date',
                expiry_date: 'Expiry Date',
                offer_duration: '60 Minutes',
                stored_for_future_use_days: '2 days',
                qr_code_details: 'QR Code Information',
                certificate: 'Certificate',
                image: 'Offer Image',
                image1: 'Additonal Image 1',
                image2: 'Additional Image 2',
                image3: 'Additional Image 3',
                image4: 'Additional Image 4',
                image5: 'Additional Image 5',
                banner_image: 'Promotion Logo',
                locationPageImage: 'Location Page Image',
                displayOnChargeLocation: 'Display On Charge Location Screen',
                promotion_button_text: 'Promotion Button Text',
            },
            label: {
                name: 'Name',
                company: 'Company',
                description: 'Description',
                start_date: 'Start Date',
                expiry_date: 'Expiry Date',
                offer_duration: 'Offer Duration (Minutes)',
                stored_for_future_use_days: 'Save for future use (days)',
                always_display_on_partner_promotion: 'Always Display Partner Promotion',
                qr_code_details: 'QR Code',
                certificate: 'Certificate',
                image: 'Offer Image',
                banner_image: 'Promotion Logo (1030 X 430)',
                layout: 'Screen Layout',
                note1: 'Please note that, You need to mention <strong>##image##</strong> and <strong>##qrcode##</strong> over screen layout HTML to replace the respective details accordingly. Additional images can be added to a layout by using the code <strong>##image0X##</strong>, where X can range from 1 to 5.',
                qr_code_note:
                    'Please note that, You need to mention <strong>##ChargeTransID##</strong>, <strong>##StartChargeTS##</strong>, <strong>##ChargeStationID##</strong> and <strong>##ChargeStationAddress##</strong> over QR Code to replace the respective details accordingly.',
                locationPageImage: 'Location Page Image',
                displayOnChargeLocation: 'Display On Charge Location Screen',
                partner_promotion_display_type: 'Promotion Display Type',
                promotion_button_text: 'Promotion Button Text',
                open_external_url: 'Open External URL',
                external_url: 'External URL',
                image1: 'Additional Image 1',
                image2: 'Additional Image 2',
                image3: 'Additional Image 3',
                image4: 'Additional Image 4',
                image5: 'Additional Image 5',
            },
            errors: {
                common: 'Something went wrong please try again.',
                name: {
                    valid: 'Enter valid promotion name',
                    max: 'Promotion name is too large',
                },
                description: {
                    max: 'Promotion description is too large',
                },
                offer_duration: {
                    moreThan: 'Offer duration must be greater than 0',
                    max: 'Offer duration can not be greater than 60 minutes',
                },
                stored_for_future_use_days: {
                    moreThan: 'Stored for future use day must be greater than 0',
                    max: 'Stored for future use day can not be greater than 99 days',
                },
                banner_image: {
                    dimensions: 'Promotion Logo must be 1030 X 430  dimension',
                },
                image: {
                    fileType: "File with extension '.jpg', '.png', '.svg', '.jpeg' can be uploaded",
                    location_page_image: 'Location Page Image is a required field',
                },
                certificate: {
                    fileType: "File with extension '.crt', '.cer' can be uploaded",
                },
                promotion_button_text: {
                    valid: 'Enter valid promotion button text',
                },
                external_url: {
                    url: 'External URL must be a valid URL',
                },
            },
        },
        assign: {
            header: 'Charge Stations',
            headerModal: 'Charge Station',
            placeholder: {
                name: 'Enter name',
                locationName: 'Enter Location Name',
                address: 'Address',
                tags: 'Select Tags',
            },
            label: {
                add: 'Add',
                name: 'Name',
                type: 'Type',
                address: 'Address',
                city: 'City',
                postcode: 'Post Code',
                last_updated: 'Modified Date',
                action: 'Action',
                delete: 'Delete',
            },
            button: {
                delete: 'Delete',
            },
            message: {
                deleteConfirmMesage: 'Are you sure you want to delete?',
            },
        },
    },
    CPOInterface: {
        title: 'Accounts : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Accounts',
        placeholder: {
            name: 'Name',
            status: 'Select Status',
        },
        label: {
            name: 'Name',
            party_id: 'Party Id',
            country_code: 'Country Code',
            version_url: 'Version URL',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
            enabled: 'Enabled',
            disabled: 'Disabled',
            locationGroup: 'Group Location',
            yes: 'Yes',
            no: 'No',
            rfidDriverTokens: 'Share only RFID driver tokens',
            vat_type: 'VAT Type',
            version_2_1_1: '2.1.1',
            version_2_2: '2.2',
            version_2_2_1: '2.2.1',
            external_cpo: '##COMPANY_BRAND_NAME## International CPO',
            cpo_type: 'CPO Type',
            override_tariff: 'Override Tariff',
            provides_session_total_cost_updates: 'Provides Session Total Cost Updates',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            add: 'Add',
            save: 'Save',
            edit: 'Edit',
            reset: 'Reset',
            yes: 'Yes',
            no: 'No',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
            enable: 'Enable',
            disable: 'Disable',
            getCredentials: 'Get Credentials',
            performHandshake: 'Perform Handshake',
            reHandshake: 'Re-Handshake',
            generateHandshakeToken: 'Generate Handshake Token',
            reGenerateHandshakeToken: 'Regenerate Handshake Token',
            changeMutualOCPIVersion: 'Change Mutual OCPI Version',
            handshakeDetails: 'Handshake Details',
        },
        message: {
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage:
                'Disabling this CPO will stop all OCPI communication, Hide associated charge locations from applications, Mark linked charge stations as "Removed," and remove locations from access groups. Are you sure you want to proceed?',
        },
        insert: {
            header: 'Manage Charge Point Operator',
            placeholder: {
                name: 'Name',
                party_id: 'Party Id',
                country_code: 'Country Code',
                ocpi: 'EMSP',
                version_url: 'Version URL of CPO',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                colour_code: 'Colour Code',
                back_office_url: 'Back Office URL',
                vat_type: 'VAT Type',
                region: 'Select Region',
                vat: 'Select VAT',
                cpo_type: 'CPO Type',
            },
            label: {
                name: 'Name',
                party_id: 'Party Id',
                country_code: 'Country Code',
                ocpi: 'EMSP',
                version_url: 'Version URL',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                locationGroup: 'Group Location',
                rfidDriverTokens: 'Share only RFID driver tokens',
                colour_code: 'Colour Code',
                back_office_url: 'Back Office URL',
                vat_type: 'VAT Type',
                disableLocationPatchPutRemovals: 'Disable Location PATCH/PUT removals',
                enableAutoMaxPowerCalculation: 'Enable auto max power calculation',
                mutual_ocpi_version: 'Mutual OCPI Version',
                externalCPO: 'Associated Region',
                is_external: '##COMPANY_BRAND_NAME## International CPO',
                defaultVat: 'Default VAT (Override)',
                gmbAccountID: 'GMB Account ID',
                cpo_type: 'CPO Type',
            },
            errors: {
                common: 'Something went wrong please try again.',
                name: {
                    valid: 'Enter valid CPO name',
                },
                party_id: {
                    valid: 'Enter valid Party Id',
                },
                country_code: {
                    valid: 'Enter valid Country Code',
                },
                version_url: {
                    url: 'Version URL must be a valid URL',
                },
                colour_code: {
                    valid: 'Enter valid Colour Code',
                },
                back_office_url: {
                    url: 'Back Office URL must be a valid URL',
                },
            },
        },
        versionEndpoints: {
            header: 'Version Endpoints',
            label: {
                version: 'Version',
                identifier: 'Identifier',
                role: 'Role',
                url: 'URL',
                last_executed: 'Last Sync Executed On',
            },
        },
        modal: {
            message:
                'You are marking this CPO as ##COMPANY_BRAND_NAME## International CPO, you need to add this CPO locations manually in public access group',
            okButton: 'OK',
        },
        confirmationModal: {
            header: 'Update Mutual OCPI Version',
            message: 'Are you sure you want to update Mutual OCPI Version?',
        },
        performHandshakeModal: {
            handshakeHeader: 'Perform Handshake',
            reHandshakeHeader: 'Perform Re-handshake',
            label: {
                mutual_ocpi_version: 'Mutual OCPI Version',
                version_url: 'Version URL',
                handshake_token: 'Handshake Token',
            },
            placeholder: {
                mutual_ocpi_version: 'Mutual OCPI Version',
                version_url: 'Version URL',
                handshake_token: 'Handshake Token',
            },
            button: {
                cancel: 'Cancel',
                generateHandshakeToken: 'Generate Handshake Token',
                confirm: 'Confirm',
                connect: 'Connect',
                reconnect: 'Reconnect',
            },
            confirmationModal: {
                header: 'Perform Handshake',
                rehandshakeMessage:
                    'CPO credentials will be changed after re-handshake. Are you sure you want to proceed with the re-handshake?',
                tokenGeneratedMessage:
                    'The handshake token for the CPO has already been generated. If the token is given to the CPO and the CPO tries to perform a handshake with the EMSP, it might fail. Are you sure you want to proceed with the re-handshake?',
            },
            cpoAuthTokenMessage: 'The default value shown here is CPO Auth Token',
        },
        generateHandshakeTokenModal: {
            header: 'Generate Handshake Token',
            reGenerateTokenHeader: 'Re-Generate Handshake Token',
            label: {
                handshakeToken: 'Handshake Token',
                emsp_auth_token: 'EMSP Auth Token',
                emspVersionURL: 'EMSP Version URL',
            },
            Placeholder: {
                handshakeToken: 'Handshake Token',
                emsp_auth_token: 'EMSP Auth Token',
            },
            button: {
                save: 'Save',
                copyToClipboard: 'Copy to Clipboard',
                generateToken: 'Generate',
                reGenerateToken: 'Regenerate',
                confirm: 'Confirm',
                cancel: 'Cancel',
            },
            copyToClipboard: {
                success: 'Token copied to clipboard',
                failed: 'Failed To copy token',
            },
            confirmationModal: {
                confirmationMessage:
                    'If the old handshake token is given to the CPO, it might fail if the CPO tries to use it for the handshake. Are you sure you want to save the new handshake token?',
                header: 'Save Token',
            },
            emspAuthTokenMessage: 'The default value shown here is EMSP Auth Token',
        },
        changeMutualOCPIVersionModal: {
            header: 'Change Mutual OCPI Version',
            label: {
                mutualOCPIVersion: 'Mutual OCPI Version',
            },
            button: {
                save: 'Save',
                cancel: 'Cancel',
                confirm: 'Confirm',
            },
            confirmationModal: {
                confirmationMessage: 'Are you sure you want to update Mutual OCPI Version?',
            },
        },
        handshakeDetailsModal: {
            header: 'Handshake Details',
            label: {
                version_url: 'Version URL',
                handshakeToken: 'Handshake Token',
                emspAuthToken: 'EMSP Auth Token',
                cpoAuthToken: 'CPO Auth Token',
            },
        },
    },
    CPOInternalTransfers: {
        title: 'Internal Transfers : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Internal Transfers',
        transferDetailTitle: 'Transfer Details : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        transferDetailHeader: 'Transfer Details',
        label: {
            transfer_id: 'Transfer ID',
            gross_value: 'Gross Value',
            created_date: 'Created Date',
            action: 'Action',
            transferNumber: 'Transfer Number',
            transferDate: 'Transfer Date',
            transaction: 'Transaction ID',
            transactionStartDate: 'Transaction Start Date',
            transactionEndDate: 'Transaction End Date',
            publicCardId: 'Public Card ID',
            driverAccountId: 'Driver Account ID',
            driverName: 'Driver/Vehicle No.',
            stationId: 'Station ID',
            stationName: 'Station Name',
            stationAddress: 'Station Address',
            kwh: 'kWh',
            price_per_kwh: 'Price/kWh',
            disable: 'DISABLED',
        },
        placeholder: {
            start_date: 'Start Date',
            end_date: 'End Date',
            status: 'Status',
            cpo: 'Select CPO',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            action: 'Action',
        },
        errors: {
            cpo: {
                required: 'Please select CPO',
            },
        },
    },
    PSPSetting: {
        title: 'Payment Service Providers : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Payment Service Providers',
        placeholder: {
            name: 'Name',
            status: 'Select Status',
            type: 'Select Type',
        },
        label: {
            name: 'Name',
            code: 'Code',
            type: 'Type',
            description: 'Description',
            store_name: 'Store',
            department_name: 'Department',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
            enabled: 'Enabled',
            disabled: 'Disabled',
            details: 'Details',
            key: 'Key',
            value: 'Value',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            add: 'Add',
            save: 'Save',
            edit: 'Edit',
            reset: 'Reset',
            yes: 'Yes',
            no: 'No',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
            enable: 'Enable',
            disable: 'Disable',
            getCredentials: 'Get Credentials',
            delete: 'Delete',
        },
        message: {
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
        },
        insert: {
            header: 'Manage Payment Service Provider',

            placeholder: {
                name: 'Name',
                type: 'Type',
                description: 'Description',
                store_name: 'Store Name',
                store_id: 'Store Id',
                merchant_name: 'Merchant Name',
                merchant_id: 'Merchant Id',
                department_name: 'Department Name',
                department_id: 'Department Id',
                signature_key: 'Signature Key',
                secret_key: 'Secret Key',
                user_name: 'User Name',
                password: 'Password',
                data: 'Data',
                category: 'Category',
                url: 'URL',
                acquirerId: 'Acquirer Id',
                firstName: 'First Name',
                lastName: 'Last Name',
                houseName: 'House Name',
                postcode: 'Postcode',
                donationProviderType: 'Donation Povider Type',
                isGiftAid: 'Is Gift Aid',
                donationStoreId: 'Donation Store Id',
                donationMerchantNumber: 'Donation Merchant Number',
                clientID: 'Client ID',
                clientSecret: 'Client Secret',
                terminalID: 'Terminal ID',
                enableCardRefunds: 'Enable Card Refunds',
                enableCardVerification: 'Enable Card Verification',
                enableCharity: 'Enable charity',
            },
            label: {
                name: 'Name',
                type: 'Type',
                firstName: 'First Name',
                lastName: 'Last Name',
                houseName: 'House Name',
                postcode: 'Postcode',
                donationProviderType: 'Donation Povider Type',
                isGiftAid: 'Is Gift Aid',
                donationStoreId: 'Donation Store Id',
                donationMerchantNumber: 'Donation Merchant Number',
                code: 'Code',
                description: 'Description',
                store_name: 'Store Name',
                store_id: 'Store Id',
                merchant_name: 'Merchant Name',
                merchant_id: 'Merchant Id',
                department_name: 'Department Name',
                department_id: 'Department Id',
                signature_key: 'Signature Key',
                secret_key: 'Secret Key',
                user_name: 'User Name',
                password: 'Password',
                data: 'Data',
                action_urls: 'Action URLs',
                category: 'Category',
                url: 'URL',
                acquirerId: 'Acquirer Id',
                clientID: 'Client ID',
                clientSecret: 'Client Secret',
                terminalID: 'Terminal ID',
                enableCardRefunds: 'Enable Card Refunds',
                enableCardVerification: 'Enable Card Verification',
                enableCharity: 'Enable charity',
                mobileMerchantId: 'Mobile Merchant Id',
                mobileMerchantPassword: 'Mobile Merchant Password',
                enableIncrementalAuthorizations: 'Enable Incremental Authorizations',
                excludedCardsForIncrementalAuthorizations: 'Excluded Cards For Incremental Authorizations',
            },
            errors: {
                common: 'Something went wrong please try again.',
                name: {
                    valid: 'Enter valid name',
                },
                code: {
                    valid: 'Enter valid Code',
                },
                url: {
                    valid: 'URL must be a valid URL',
                },
                DatatransSupportCards: {
                    valid: 'Please enter valid value for DatatransSupportCards',
                },
            },
        },
    },
    RFIDCards: {
        title: 'RFID cards : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'RFID cards',
        placeholder: {
            name: 'Driver Name / Email / Organisation',
            manufacturer: 'Manufacturer',
            part_id: 'Part Id',
            public_card_id: 'Public Card Id',
            status: 'Select Status',
            mifare_uid: 'Mifare UID',
        },
        label: {
            name: 'Allocated To',
            email_vehicle: 'Associated Account',
            manufacturer: 'Manufacturer',
            part_id: 'Part Id',
            public_card_id: 'Public Card Id',
            private_card_id: 'Private Card Id',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
            enabled: 'Enabled',
            disabled: 'Disabled',
            delete: 'Delete',
            deAllocate: 'Remove Association',
            view: 'View Detail',
            allocateCardToOrganisation: 'Allocate bulk cards to Organisation',
            mifare_uid: 'MIFARE UID',
            reinstate: 'Reinstate Card',
            card_type: 'Card Type',
            removeBulkAssociation: 'Remove RFID Cards Association in Bulk',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            add: 'Add',
            addBulk: 'Add bulk cards to manufacture',
            assing: 'Assign RFID Cards',
            allocateRFIDCard: 'Allocate RFID Card',
            import: 'Import Manufacturing File',
            export: 'Export Manufacturing File',
            save: 'Save',
            edit: 'Edit',
            reset: 'Reset',
            yes: 'Yes',
            no: 'No',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
            enable: 'Enable',
            disable: 'Disable',
            getCredentials: 'Get Credentials',
            delete: 'Delete',
            deAllocate: 'Remove Association',
            view: 'View Detail',
            reinstate: 'Reinstate Card',
            forceCPOUpdate: 'Force CPO Update',
        },
        errors: {
            export: {
                notSeletedCards: 'Please select Awaiting Export cards',
            },
        },
        message: {
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            deleteConfirmMesage: 'Are you sure you want to delete?',
            deAllocateConfirmMesage: 'Are you sure you want to remove the RFID Card Association to an Account?',
            reinstateConfirmMessage: 'Are you sure you want to reinstate the RFID Card?',
            forceCPOUpdateConfirmMessage: 'Are you sure you want to force update token in CPO system?',
        },
        insert: {
            header: 'Manage RFID cards',

            placeholder: {
                manufacturer: 'Manufacturer Name',
                part_id: 'Part Id',
                public_card_id: 'Public card Id',
                private_card_id: 'Private Card Id',
                mifare_uid: 'Mifare UID',
                card_type: 'Card Type',
            },
            label: {
                manufacturer: 'Manufacturer',
                part_id: 'Part Id',
                public_card_id: 'Public card Id',
                private_card_id: 'Private Card Id',
                mifare_uid: 'Mifare UID',
                card_type: 'Card Type',
            },
            errors: {
                common: 'Something went wrong please try again.',
                name: {
                    valid: 'Enter valid name',
                },
                code: {
                    valid: 'Enter valid Code',
                },
                url: {
                    valid: 'URL must be a valid URL',
                },
            },
        },
        bulkCards: {
            header: 'Add Bulk Cards',
            placeholder: {
                manufacturer: 'Manufacturer Name',
                part_id: 'Part Id',
                no_of_cards: '100 Cards',
                cardType: 'Select Card Type',
            },
            label: {
                manufacturer: 'Manufacturer Name',
                part_id: 'Part Id',
                no_of_cards: 'No of Cards',
                cardType: 'Card Type',
            },
            button: {
                yes: 'Create Cards',
                no: 'Cancel',
            },
            errors: {
                no_of_cards: {
                    min: 'No of Cards can not be less than 1',
                },
            },
        },
        assignCards: {
            header: 'Assign RFID Cards',
            header2: 'You have selected X cards.',
            selectedCard: 'You have selected 1 card.',
            placeholder: {
                manufacturer: 'Manufacturer Name',
                part_id: 'Part Id',
                no_of_cards: '100 Cards',
            },
            label: {
                driver: 'Driver',
                organisation: 'Organisation',
                no_of_cards: 'No of Cards',
            },
            button: {
                yes: 'Assign',
                no: 'Cancel',
            },
            form: {
                type: {
                    driver: 'Driver',
                    organisation: 'Organisation',
                },
                driver: 'Driver',
                organisation: 'Organisation',
                placeholder: {
                    driver: 'Select Driver',
                    organisation: 'Select Organisation',
                },
            },
            errors: {
                notSeletedCards: 'Please select available cards',
            },
        },
        disableCards: {
            header: 'Disable',
            header2: 'Are you sure you want to disable?',
            placeholder: {
                comment: 'Enter comment',
            },
            label: {
                comment: 'Comment',
            },
            button: {
                yes: 'Yes',
                no: 'No',
            },
        },
        allocateCards: {
            header: 'Allocate RFID Cards',
            placeholder: {
                file: 'Select CSV file',
                selectOrganisation: 'Select Organisation',
            },
            label: {
                file: 'CSV File',
                organisation: 'Organisation',
                mifareUID: 'Mifare UID',
                publicCardID: 'Public Card ID',
                clickHere: 'Click here',
                downloadTemplate: 'to download template',
            },
            button: {
                allocate: 'Allocate',
                cancel: 'Cancel',
            },
            errors: {
                file: {
                    fileType: "File with extension '.csv' can be uploaded.",
                },
            },
        },
        removeAssociation: {
            header: 'Remove RFID Cards Association in Bulk',
            placeholder: {
                file: 'Select CSV file',
            },
            label: {
                file: 'CSV File',
                clickHere: 'Click here',
                downloadTemplate: 'to download template',
            },
            button: {
                save: 'Save',
                cancel: 'Cancel',
            },
            errors: {
                file: {
                    fileType: "File with extension '.csv' can be uploaded.",
                },
                maxRFIDRecordsReached:
                    'Your uploaded CSV file reached the maximum number of 10,000 RFID card public card ID records, please reduce the RFID cards public card ID records on the csv file.',
            },
        },
        importCards: {
            header: 'Import RFID Cards',
            placeholder: {
                file: 'Select CSV file',
            },
            label: {
                file: 'CSV File',
            },
            button: {
                yes: 'Import',
                no: 'Cancel',
            },
            errors: {
                file: {
                    fileType: "File with extension '.csv' can be uploaded.",
                },
            },
        },
        importCardsDetails: {
            header: 'RFID Cards Import Details',
            label: {
                unSuccessfullImport: 'Following cards cannot be imported',
                successfullImport: 'Following cards are imported successfully',
                failerReason: 'Failure Reason',
                publicCardId: 'Public Card ID',
            },
            message: {
                defualtErrorMessage: 'There is an issue importing the following cards.',
            },
        },
        rfidDetails: {
            label: {
                event_date: 'Event Date',
                chargeLocation: 'Charge Location',
                charge_station_name: 'Station Name',
                response_status: 'Response Status',
            },
        },
    },
    referralPromotion: {
        title: 'Referral Promotion: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Referral Promotions',
        manageReferralPromotion: 'Manage Referral Promotion',
        label: {
            name: 'Name',
            code: 'Code',
            minCharge: 'Min. Charge',
            maxLimit: 'Max. Limit',
            maxRefreeLimit: 'Max. Referee Limit',
            createdDate: 'Created Date',
            status: 'Status',
            action: 'Action',
            disabled: 'Disabled',
            enabled: 'Enabled',
            delete: 'Delete',
            enable: 'Enable',
            disable: 'Disable',
            promotionCode: 'Promotion Code',
            description: 'Description',
            maxReferralLimit: 'Maximum Referral Limit',
            minChargeValue: 'Minimum Charge Value',
            refereeBonus: 'Referee Bonus',
            referrerBonus: 'Referrer Bonus',
        },
        button: {
            search: 'Search',
            back: 'Back',
            add: 'Add',
            reset: 'Reset',
            edit: 'Edit',
            delete: 'Delete',
            enable: 'Enable',
            disable: 'Disable',
            save: 'Save',
            cancel: 'Cancel',
            action: 'Action',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
        },
        placeholder: {
            name: 'Name',
            code: 'Code',
            selectPromotion: 'Select Promotion',
            selectStatus: 'Select Status',
            promotionCode: 'Promotion Code',
            description: 'Description',
            maxReferralLimit: 'Maximum Referral Limit',
            minChargeValue: 'Minimum Charge Value',
            refereeBonus: 'Referee Bonus',
            referrerBonus: 'Referrer Bonus',
        },
        errors: {
            name: {
                valid: 'Enter valid promotion name',
            },
            promotionCode: {
                valid: 'Enter valid promotion code',
            },
            maxReferralLimit: {
                moreThan: 'Max referral limit must be greater than zero',
            },
            referrerBonus: {
                max: 'Referrer Bonus value can not be greater than ##MAX_REFERRAL_BONUS##',
            },
            refereeBonus: {
                max: 'Referee Bonus value can not be greater than ##MAX_REFERRAL_BONUS##',
            },
        },
    },
    termsConditions: {
        title: 'Terms & Conditions: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Terms & Conditions',
        manageTermsConditions: 'Manage Terms & Conditions',
        label: {
            enabled: 'Enabled',
            disabled: 'Disabled',
            name: 'Name',
            description: 'Description',
            apply_to: 'Apply To',
            mandatory_for_user: 'Mandatory For User',
            status: 'Status',
            delete: 'Delete',
            content: 'Policy Content',
            yes: 'Yes',
            no: 'No',
            draft: 'Draft',
            published: 'Published',
        },
        placeholder: {
            name: 'Name',
            description: 'Description',
            select: {
                apply_to: 'Apply To',
                status: 'Select Status',
            },
        },
        columns: {
            name: 'Name',
            description: 'Description',
            applyto: 'Apply To',
            mandatory_for_user: 'Mandatory',
            status: 'Status',
            action: 'Action',
            modified_date: 'Modified On',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            action: 'Action',
            edit: 'Edit',
            add: 'Add',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            yes: 'Yes',
            no: 'No',
        },
        errors: {
            name: {
                valid: 'Enter valid name',
            },
            invalidFormat: 'Please upload valid image format',
            common: 'Something went wrong please try again.',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
        },
    },
    rewardPromotion: {
        title: 'Reward Promotions: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'IV Reward Promotions',
        manageRewardPromotion: 'Manage IV Reward Promotion',
        label: {
            name: 'Name',
            code: 'Code',
            valuesPerkwh: 'Values per kWh',
            monetoryValue: 'Monetary value',
            redemptionBlock: 'Redemption Block',
            createdDate: 'Created Date',
            status: 'Status',
            enabled: 'Enabled',
            disabled: 'Disabled',
            action: 'Action',
            delete: 'Delete',
            enable: 'Enable',
            disable: 'Disable',
            promotionCode: 'Promotion Code',
            description: 'Description',
            expired: 'Expired',
            locationApplicable: 'Charge Location Applicable',
            voltsPerkwh: 'Volts per kWh',
            confirmation: 'Confirmation',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            save: 'Save',
            add: 'Add',
            edit: 'Edit',
            reset: 'Reset',
            delete: 'Delete',
            enable: 'Enable',
            disable: 'Disable',
            action: 'Action',
            back: 'Back',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            uncheckConfirmMesage:
                'Upon unchecking this checkbox, All charge locations associated with this promotion will be removed. Are you sure you want to remove it?',
        },
        placeholder: {
            name: 'Name',
            code: 'Code',
            selectPromotion: 'Select promotion',
            selectStatus: 'Select Status',
            locationApplicable: 'Charge Location Applicable',
            voltsPerkwh: 'Volts per kWh',
        },
        errors: {
            name: {
                valid: 'Enter valid promotion name',
            },
            promotionCode: {
                valid: 'Enter valid promotion code',
            },
            monetoryValue: {
                moreThan: 'Monetary value must be greater than zero',
                lessThan: 'Monetary value must be less than or equal to 99999.99',
                typeError: 'Enter valid monetary value',
            },
            redemptionPointBlock: {
                moreThan: 'Redemption Block must be greater than zero',
            },
            valuePerKwh: {
                moreThan: 'Value must be greater than zero',
            },
        },
    },
    amenitys: {
        title: 'Amenities: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Amenities',
        manageamenitys: 'Manage Amenities',
        chargeStationsList: 'Charge Stations',
        chargeLocation: 'Charge Locations',
        amenityTranslationNote:
            "Please enter the amenity details for admin users/ drivers in the region's respective language. When no details have been entered for a specific language, the system will show the default details.",
        label: {
            enabled: 'Enabled',
            disabled: 'Disabled',
            name: 'Name',
            imageUpload: 'Icon (34 X 34)',
            language: 'Language',
            image: 'Icon',
            description: 'Description',
            default_search: 'Default Search',
            status: 'Status',
            delete: 'Delete',
            csvFile: 'CSV File',
            importAmenityHeader: 'Import Amenities',
            chargeLocation: {
                name: 'Name',
                type: 'Type',
                address: 'Address',
                city: 'City',
                postal_code: 'Post Code',
                modifiedDate: 'Modified Date',
                action: 'Action',
            },
            charge_station_name: 'Charge_Station_Name',
            charge_point: 'Charge_Point',
            charge_location_name: 'Charge_Location_Name',
            latitude: 'Latitude',
            longitude: 'Longitude',
            location_address: 'Location_Address',
            amenities: 'Amenities',
            amenity_type: 'Amenity Type',
        },
        placeholder: {
            name: 'Name',
            description: 'Description',
            file: 'Select CSV file',
            select: {
                status: 'Select Status',
                amenity_type: 'Select Type',
            },
        },
        columns: {
            name: 'Name',
            description: 'Description',
            status: 'Status',
            action: 'Action',
            amenity_type: 'Type',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            action: 'Action',
            edit: 'Edit',
            add: 'Add',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            yes: 'Yes',
            no: 'No',
            disable: 'Disable',
            enable: 'Enable',
            import: 'Import',
        },
        errors: {
            common: 'Something went wrong please try again.',
            name: {
                valid: 'Please enter a valid name.',
            },
            image: {
                fileType: "File with extension '.jpg', '.png', '.svg', '.jpeg' can be uploaded.",
                dimensions: 'Icon must be 34 X 34  dimension',
                required: 'Icon is a required field',
            },
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
        },
    },
    vehicle: {
        title: 'Vehicle: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Vehicles',
        columns: {
            name: 'Name',
            registerNo: 'Register No',
            make: 'Make',
            model: 'Model',
            chargeType: 'Charge Type',
            batteryCapacity: 'Battery Capacity',
            consumption: 'Consumption',
        },
        placeholder: {
            nameEmail: 'Name / Email',
            makeModelRegistrationNo: 'Make / Model / Register No',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
        },
    },
    incompleteSessions: {
        title: 'Incomplete Sessions: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Incomplete Sessions',
        placeholder: {
            nameOrEmail: 'Name / Email',
            locationOrStation: 'Location / Station',
            startDate: 'Start Date',
            endDate: 'End Date',
            status: 'Select Status',
            comment: 'Enter your comments',
        },
        label: {
            invalid: 'Invalid',
            generateCDR: 'Generate CDR',
            totalEnergy: 'Total Energy',
            totalCost: 'Total Cost',
            comment: 'Enter your comments',
            cancelCDR: 'Cancel CDR',
        },
        columns: {
            name: 'Name',
            location: 'Location',
            sessionId: 'Session Id',
            startDate: 'Start Date',
            modifiedDate: 'Modified Date',
            time: 'Time',
            energy: 'Energy </br> (kWh)',
            cost: 'Cost',
            status: 'Status',
            action: 'Action',
        },
        button: {
            action: 'Action',
            generateCDR: 'Generate CDR',
            search: 'Search',
            reset: 'Reset',
            save: 'Save',
            cancel: 'Cancel',
            yes: 'Yes',
            no: 'No',
            cancelCDR: 'Cancel CDR',
        },
        error: {
            max: 'Maximum 250 characters allowed',
        },
        message: {
            cancelCDRMessage: 'Are you sure you want to cancel session?',
            cancelBulkCDRMessage: 'Are you sure you want to cancel session for selected records?',
            selectCDR: 'Please select Incomplete sessions',
        },
    },
    ocpiSessions: {
        title: 'OCPI Sessions: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Sessions',
        placeholder: {
            nameOrEmail: 'Name / Email',
            locationOrStation: 'Location / Station',
            startDate: 'Start Date',
            endDate: 'End Date',
            status: 'Select Status',
            comment: 'Enter you comments',
        },
        columns: {
            name: 'Name',
            location: 'Location',
            sessionId: 'Session Id',
            startDate: 'Start Date',
            endDate: 'End Date',
            time: 'Time',
            energy: 'Energy </br> (kWh)',
            cost: 'Cost',
            status: 'Status',
            action: 'Action',
            vehicleNumber: 'Vehicle Number',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            complete: 'Complete',
        },
        label: {
            complete: 'Complete',
            completeSessions: 'Complete Charging Sessions',
        },
        message: {
            completeConfirmMessage: 'Would you like to complete the charging session?',
            stopBulkSessionsMessage: 'Would you like to complete selected charging sessions?',
            selectSession: 'Please select Charging Sessions',
        },
    },
    organisation: {
        title: 'Manage Organisation: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Organisation',
        manageOrganisation: 'Manage Organisation',
        label: {
            name: 'Name',
            description: 'Description',
            address: 'Address',
            city: 'City',
            county: 'County',
            postal_code: 'Postal Code',
            contact_person: 'Contact Person',
            email: 'Email',
            phone_number: 'Phone No',
            payment_mode: 'Payment Mode',
            payment_schedule: 'Payment Schedule',
            user_group_ids: 'User Groups',
            enabled: 'Enabled',
            disabled: 'Disabled',
            amount: 'Credit Limit',
            po_number: 'PO Number',
            finance_account_number: 'Finance Account Number',
            account_contact_email: 'Account Contact Email',
            remaining_credit: 'Remaining Credit (%)',
            remoteChargePassword: 'Start Remote Charge Password',
            is_deleted: 'Is Deleted',
            yes: 'Yes',
            deleted: 'Deleted',
            dailySpendLimit: 'Daily Spend Limit',
            weeklySpendLimit: 'Weekly Spend Limit',
            monthlySpendLimit: 'Calendar Month Spend Limit',
            defaultSpendLimitGroup: 'Default Spend Limit Group',
            updateSpendLimitAssociation: 'Spend Limit Group Association',
            promotionUpdate: 'Promotion Update',
            currentPromotion: 'Current Promotion',
            newPromotion: 'New Promotion',
        },
        placeholder: {
            name: 'Name',
            name_or_email_or_contact_person: 'Name/Contact Person/Email',
            description: 'Description',
            address: 'Address',
            city: 'City',
            county: 'County',
            postal_code: 'Postal Code',
            contact_person: 'Contact Person',
            email: 'Email',
            phone_number: 'Phone No',
            select: {
                status: 'Select Status',
                payment_mode: 'Select Payment Mode',
                payment_schedule: 'Select Payment Schedule',
                user_group_ids: 'Select User Groups',
            },
            amount: 'Credit Limit',
            po_number: 'PO Number',
            finance_account_number: 'Finance Account Number',
            remaining_credit: 'Remaining Credit (%)',
            remoteChargePassword: 'Start Remote Charge Password',
            enableSpendLimit: 'Enable Spend Limit',
            defaultSpendLimitGroup: 'Select Default Spend Limit Group',
            selectCurrentPromotion: 'Select Current Promotion',
            selectNewPromotion: 'Select New Promotion',
        },
        columns: {
            name: 'Name',
            contact_Person: 'Contact Person',
            email: 'Email',
            payment_mode: 'Payment Mode',
            payment_schedule: 'Payment Schedule',
            created_date: 'Created On',
            status: 'Status',
            action: 'Action',
            remote_charge_password: 'Start Remote Charge Password',
            promotion: 'Promotion',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            action: 'Action',
            edit: 'Edit',
            add: 'Add',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            yes: 'Yes',
            no: 'No',
            enable: 'Enable',
            disable: 'Disable',
            permission: 'API Permission',
            assignSpendLimitGroup: 'Assign Spend Limit Group',
        },
        errors: {
            name: {
                valid: 'Please enter valid name',
            },
            contact_person: {
                valid: 'Please enter valid contact person',
            },
            email: {
                required: 'Please enter email ddress',
                email: 'Please enter valid email address',
            },
            phoneNo: {
                required: 'Please enter phone number',
                match: 'Please enter valid phone number',
            },
            amount: {
                moreThan: 'Amount must be greater than 0',
                maxcredit: 'Max limit reached for account credit',
            },
            po_number: {
                valid: 'Please enter valid PO number',
            },
            finance_account_number: {
                valid: 'Please enter valid finance account number',
            },
            account_contact_email: {
                required: 'Please enter at least one email address',
                maxLimit: 'Maximum limit reached for account contact email',
            },
            remaining_credit: {
                match: 'Please enter valid remaining credit',
                maxCredit: 'Remaining credit maximum value should not exceed 100',
                minCredit: 'Remaining credit minimum value should not be less than 0',
            },
            value: {
                moreThan: 'Value must be greater than 0',
                lessThan: 'Value must be less than or equal to 5000',
                number: 'Value must be a number',
                lessThanWeekly: 'The value must be less than or equal to the weekly spend limit',
                lessThanMonthly: 'The value must be less than or equal to the monthly spend limit',
            },
            spend_limit: {
                moreThan: 'Weekly spend limit must be more than daily spend limit',
                lessThan: 'Daily spend limit must be less than weekly spend limit',
            },
            address: 'minimum 10 character is required',
            addressValid: 'Please enter the valid address',
            user_group: {
                required: 'Please select at least one user group',
            },
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            assignAllDriversToDefaultGroup:
                'Would you like to assign all the drivers of this organisation to default spend limit group?',
            updatePromotionConfirmMessage: 'Are you sure you want to update promotion for selected organisations?',
            selectOneRecord: 'Please select at least one organisation for promotion update',
            promotionAssignMessage: 'New promotion will be assigned to following organisations:',
        },
        permission: {
            header: 'API Permission',
            label: {
                description: 'Description',
                action: 'APIs',
            },
        },
    },
    transactionLogs: {
        title: 'Transaction Logs: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Transaction Logs',
        placeholder: {
            page: 'Select Page',
            email: 'Email Address',
            startDate: 'Start Date',
            endDate: 'End Date',
            fieldName: 'Field Name',
            content: 'Content',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
        },
        label: {
            tableName: 'Table Name',
            fieldName: 'Field Name',
            oldValue: 'Old Value',
            newValue: 'New Value',
            user: 'User',
            logDate: 'Log Date',
            action: 'Action',
            goToPage: 'Go To Page',
        },
    },
    organisationAccountBalance: {
        title: 'Organisation Account Balance : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Organisation Account Balance',
        manageUser: 'Manage Organisation Account Balance',
        columns: {
            currentBalance: 'Current Balance',
            closingBalance: 'Closing Balance',
            availableCredit: 'Available Credit',
            unbilledAmount: 'Unbilled Amount',
            name: 'Name',
            contact_Person: 'Contact Person',
            email: 'Email',
            payment_mode: 'Payment Mode',
            payment_schedule: 'Payment Schedule',
            balance: 'Balance',
            status: 'Status',
            action: 'Action',
            refund: 'Amend account balance',
        },
        placeholder: {
            name: 'Name/Contact Person/Email',
            description: 'Comment',
            amount: 'Enter the Amount to Credit/Debit',
            select: {
                status: 'Select Status',
                payment_mode: 'Payment Mode',
                payment_schedule: 'Payment Schedule',
            },
            invoice: 'Select Invoice',
        },
        label: {
            description: 'Comment',
            amount: 'Enter the Amount to Credit/Debit',
            payment_settlement: 'Balance Amendment - Request',
            enabled: 'Enabled',
            disabled: 'Disabled',
            invoice: 'Invoice',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            save: 'Save',
            add: 'Add',
            edit: 'Edit',
            reset: 'Reset',
            action: 'Action',
            send_for_approval: 'Send for Approval',
            accept: 'Accept',
        },
        errors: {
            amount: {
                moreThan: 'Amount must be greater/less than 0',
                maxcredit: 'Max limit reached for account credit',
                maxdebit: 'Max limit reached for account debit',
            },
        },
    },
    driverAward: {
        rewardTitle: 'Reward Balance - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        approvalRequest: 'Reward Balance Approvals - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        rewards: 'Reward Balance',
        approvalRequests: 'Reward Balance Approvals',
        label: {
            name: 'Name',
            email: 'Email',
            iVRewardPromotion: 'IV Reward Promotion',
            balance: 'Balance',
            status: 'Status',
            action: 'Action',
            enabled: 'Enabled',
            disabled: 'Disabled',
            location: 'Location',
            date: 'Date',
            energy: 'Energy (kWh)',
            cost: 'Cost',
            rewardPoint: 'Reward Point',
            rewardSettelemant: 'Reward settlement',
            description: 'Description',
            credit: 'Credit',
            debit: 'Debit',
            iVRewardSettelemant: 'Rewards - Settlement',
            amount: 'Amount',
            request_by: 'Requested By',
            request_date: 'Requested On',
            review_by: 'Reviewed By',
            review_date: 'Reviewed On',
            review_comment: 'Reviewer Comments',
            approvalRequest: 'Approval Request',
            enterComments: 'Enter your comments',
            transaction_date: 'Transaction Date',
            debit_credit: 'Debit/Credit',
            type: 'Type',
            requested_by_comment: 'Requested By Comments',
            volts: 'Volts',
            commentsFrom: 'Comments From',
            approve: 'Approve',
            decline: 'Decline',
            federatedAccount: 'Federated Account Type',
        },
        placeholder: {
            nameOrEmail: 'Name/Email',
            selectIVAwardPromotion: 'Select IV Award Promotion',
            selectStatus: 'Select Status',
            startDate: 'Start Date',
            endDate: 'End Date',
            description: 'Description',
            volts: 'Volts',
            enterComments: 'Enter your comments',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            save: 'Save',
            cancel: 'Cancel',
            decline: 'Decline',
            approve: 'Approve',
            send_for_approval: 'Send for Approval',
        },
        errors: {
            type: { required: 'Credit or Debit the settlement' },
            volts: { typeError: 'Enter valid volts', moreThan: 'Volts must be greater/less than 0' },
            status: { selectApprovalOrReject: 'Approve/Decline this request.' },
        },
    },
    organisationdashboard: {
        title: 'Organisation Dashboard: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Organisation Dashboard',
        dashboard: 'Dashboard',
        label: {
            filter: 'Filter',
            organisation: 'Organisation',
            selectOrganisations: 'Select Organisations',
            dateRange: 'Date Range',
            driverGroup: 'Driver Groups',
            drivers: 'Driver/Vehicle',
            selectDriver: 'Select Driver/Vehicle',
            selectDriverGroup: 'Select Driver Groups',
            month: 'Month',
            year: 'Year',
            day: 'Day',
            week: 'Week',
            userSessionTitle: 'Driver Sessions',
            userSessions: 'Driver Sessions',
            totalIncomeTitle: 'Sum of Income',
            income: 'Income',
            energy: 'Energy',
            energyTitle: 'Sum of Energy (kWh)',
            selectAll: 'Select All',
            totalRFIDCards: 'Total RFID Cards',
            available: 'Available',
            allocated: 'Allocated',
            duplicate: 'Duplicate',
            disabled: 'Disabled',
            rfid: 'RFID',
            totalDriverAccounts: 'Total Driver Accounts',
            driver: 'Drivers',
            enabled: 'Enabled',
            pending: 'Pending',
            deleted: 'Deleted',
            topTenDriverVehicles: 'Top 10 Drivers/Vehicles Usage',
            driverAccount: 'Driver',
            vehicle: 'Vehicle',
            driverName: 'Driver Name',
            vehicleNumber: 'Vehicle Number',
            kwhUsage: 'kWh Usage',
            dateRangeLabel: 'Date Range :',
            both: 'Both',
            nameorvehicleno: 'Name/Vehicle No.',
            type: 'Type',
        },
        button: {
            apply: 'Apply',
            clear: 'Clear',
            syncData: 'Sync Data',
            search: 'Search',
            reset: 'Reset',
        },
    },
    organisationtransactions: {
        headerTitle: 'Organisation Transactions - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        invoiceHeader: 'Invoice Detail- ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        invoiceTitle: 'Invoice Detail',
        title: 'Organisation Transactions',
        transaction: 'Transaction',
        columns: {
            location: 'Location',
            date: 'Date',
            time: 'Time',
            cost: 'Cost',
            energy: 'Energy',
            action: 'Action',
            remark: 'Remarks',
            amount: 'Amount',
            closing: 'Closing',
            transaction: 'Transaction ID',
            name: 'Name',
            credit: 'Credit',
            debit: 'Debit',
            vehicleNumber: 'Vehicle Number',
            invoiceNumber: 'Invoice Number',
            comment: 'Comment',
            startDate: 'Start Date',
            endDate: 'End Date',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        form: {
            charge: 'Charging',
            payment: 'Payment',
            month: 'Month',
        },
        label: {
            exportAll: 'Export All',
            amount: 'Amount',
            driverName: 'Driver/Vehicle No.',
            station: 'Station',
            kwh: 'kWh',
            price_per_kwh: 'Price/kWh',
            net_value: 'Net value',
            vat_rate: 'VAT Rate',
            gross_value: 'Gross Value',
            totalBeforeVAT: 'Total Before VAT',
            VatAt: ' VAT at',
            VatRate: 'VAT Rate:',
            totalNetAmount: 'Total Net Amount',
            subTotal: 'Sub Total',
            adjustedAmount: 'Adjusted Amount',
            grandTotal: 'Grand Total',
            totalFee: ' Total Fee',
            invoiceNumber: 'Invoice Number',
            invoiceDate: 'Invoice Date',
            transaction: 'Transaction ID',
            name: 'Name',
            date: 'Date',
            publicCardId: 'Public Card ID',
            stationId: 'Station ID',
            transactionStartDate: 'Transaction Start Date',
            transactionEndDate: 'Transaction End Date',
            stationAddress: 'Station Address',
            driverAccountId: 'Driver Account ID',
            vat_amount: 'VAT Amount',
            stationName: 'Station Name',
            status: 'Status',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            back: 'Back',
            export: 'Export',
        },
        placeholder: {
            startDate: 'Start Date',
            endDate: 'End Date',
            startDateFrom: 'Start Date From',
            startDateTo: 'Start Date To',
            select: {
                organisation: 'Select Organisation',
                invoice: 'Select Invoice Number',
            },
        },
        message: {
            noDataToExport: 'There is no data to export.',
            organisation: {
                required: 'Please Select Organisation',
            },
            selectRecordToExport: 'Select any records to export.',
        },
    },
    driverVehicleAccount: {
        title: 'Driver/Vehicle Accounts : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Driver/Vehicle Accounts',
        managedriver: 'Manage Driver/Vehicle',
        importHeader: 'Upload new Accounts with RFID cards',
        importUpdateStatusHeader: 'Enable/Disable Accounts',
        importUpdateSpendGroupAssociation: 'Update Driver Spend Limit Group Association',
        placeholder: {
            name: 'Name / Email / Vehicle No',
            rfidCardNo: 'RFID Card No',
            driverGroups: 'Select Driver Groups',
            status: 'Select Status',
            first_name: 'First Name',
            last_name: 'Last Name',
            email: 'Email Address',
            vehicle_no: 'Vehicle No',
            driverGroup: 'Select Driver Groups',
            accountType: 'Select Account Type',
            publicRFIDCardNo: 'Enter the Public RFID Card No.',
            languagePreference: 'Language Preference',
        },
        label: {
            name: 'Name',
            email: 'Email',
            vehicleNo: 'Vehicle No',
            group: 'Group',
            createdDate: 'Created Date',
            status: 'Status',
            action: 'Action',
            enabled: 'Enabled',
            disabled: 'Disabled',
            cancelled: 'Cancelled',
            deleted: 'Deleted',
            delete: 'Delete',
            first_name: 'First Name',
            last_name: 'Last Name',
            vehicle_no: 'Vehicle No',
            driverGroup: 'Driver Groups',
            accountType: 'Account Type',
            assignRFIDCard: 'Assign RFID Card',
            rfidCard: 'RFID Card',
            publicRFIDCardNo: 'Enter the Public RFID Card No.',
            assign: 'Assign',
            allocatedRFIDCards: 'Allocated RFID Cards',
            file: 'CSV File',
            clickHere: 'Click here',
            downloadTemplate: 'to download template',
            errosInImportedFile: 'Errors',
            driverVehicleNo: 'Driver/Vehicle No.',
            driverVehicleDetails: 'Driver/Vehicle Details',
            error: 'Error',
            pending: 'Pending',
            card_allocated: 'RFID Card Allocated',
            driver: 'Driver (Fleet App based account)',
            vehicle: 'Vehicle (RFID based account)',
            note: 'Note: ',
            accountSetupNote:
                'Account holder will need to complete the account setup within 24 hrs via the ##COMPANY_BRAND_NAME## Fleet App using the temporary password provided via email.',
        },
        button: {
            import: 'Import',
            add: 'Add',
            search: 'Search',
            reset: 'Reset',
            edit: 'Edit',
            enable: 'Enable',
            disable: 'Disable',
            delete: 'Delete',
            yes: 'Yes',
            no: 'No',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            assignRFIDCard: 'Assign RFID Card',
            assign: 'Assign',
            action: 'Action',
            done: 'Done',
            sendEmail: 'Send Email',
            enableDisableAccounts: 'Enable/Disable Accounts',
            export: 'Export',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            sendMailConfirmMessage: 'Are you sure you want to send email?',
            mailSentSuccessMessage: 'Email sent successfully.',
        },
        errors: {
            invalidEmail: 'Please enter a valid email address.',
            invalidFirstName: 'Please enter valid first name.',
            invalidLastName: 'Please enter valid last name.',
            invalidVehicleNo: 'Please enter valid vehicle no.',
            common: 'Something went wrong please try again.',
        },
        account_type: {
            driver: 'Driver',
            vehicle: 'Vehicle',
        },
        columns: {
            public_rfid_card_no: 'Card No',
            allocatedBy: 'Allocated By',
            allocatedDate: 'Allocated Date',
            status: 'Status',
        },
    },
    chargingHistory: {
        header: 'Charging Sessions - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        title: 'Charging Sessions',
        label: {
            exportAll: 'Export',
            location: 'Location',
            date: 'Date',
            milesAdded: 'Miles Added',
            time: 'Time',
            cost: 'Cost',
            energy: 'Energy',
            action: 'Action',
            remark: 'Remarks',
            name: 'Name',
            vehicleNo: 'Vehicle No',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            back: 'Back',
        },
        placeholder: {
            startDate: 'Start Date',
            endDate: 'End Date',
            startDateFrom: 'Start Date From',
            startDateTo: 'Start Date To',
            driver: 'Name / Email / Vehicle No',
            selectDriverGroup: 'Select Driver/Vehicle Groups',
        },
        errors: {
            noDataToExport: 'There is no data to export.',
            selectRecordToExport: 'Select any records to export.',
            common: 'Something went wrong please try again.',
        },
    },
    paymentHistory: {
        header: 'Payment History- ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        title: 'Payment History',
        invoiceHeader: 'Invoice Detail- ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        invoiceTitle: 'Invoice Detail',
        label: {
            remark: 'Remarks',
            credit: 'Credit',
            debit: 'Debit',
            closing: 'Closing',
            transaction: 'Transaction ID',
            name: 'Name',
            date: 'Date',
            amount: 'Amount',
            driverName: 'Driver/Vehicle No.',
            station: 'Station',
            kwh: 'kWh',
            price_per_kwh: 'Price/kWh',
            net_value: 'Net value',
            vat_rate: 'VAT Rate',
            gross_value: 'Gross Value',
            totalBeforeVAT: 'Total Before VAT',
            VatAt: ' VAT at',
            totalFee: ' Total Fee',
            invoiceNumber: 'Invoice Number',
            invoiceDate: 'Invoice Date',
            publicCardId: 'Public Card ID',
            stationId: 'Station ID',
            transactionStartDate: 'Transaction Start Date',
            transactionEndDate: 'Transaction End Date',
            stationAddress: 'Station Address',
            driverAccountId: 'Driver Account ID',
            vat_amount: 'VAT Amount',
            stationName: 'Station Name',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        placeholder: {
            startDate: 'Start Date',
            endDate: 'End Date',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            export: 'Export',
        },
        errors: {
            noDataToExport: 'There is no data to export.',
            selectRecordToExport: 'Select any records to export.',
        },
    },
    configurations: {
        title: 'Configurations : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Configurations',
        columns: {
            name: 'Name',
            value: 'Value',
            description: 'Description',
            system_type: 'System Type',
            modifiedBy: 'Modified By',
            modifiedDate: 'Modified Date',
            action: 'Action',
        },
        button: {
            save: 'Save',
            cancel: 'Cancel',
            reset: 'Reset',
            search: 'Search',
            action: 'Action',
            edit: 'Edit',
        },
        note: 'WARNING: Changing these configuration settings may significantly impact the performance of the platform. If in doubt, please contact your system administrator.',
        errors: {
            maxLengthString: 'Please enter a value with maximum',
            maxLengthStringCharacters: 'characters',
            maxLengthNUmberCharacters: 'digits',
            valueBetween: 'Please enter a value between',
            valueGraterThen: 'Please enter a value equal or greater then',
            valueMention: 'Please provide value in mentioned range',
        },
        placeholder: {
            value: 'Enter value',
            description: 'Enter description',
            name: 'Name',
            valueSearch: 'Value',
            descriptionSearch: 'Description',
            referenceCode: 'Reference Code',
            systemType: 'Select System Type',
        },
        label: {
            value: 'Value',
            dataType: 'Data Type',
            description: 'Description',
            system: 'SYSTEM',
            driver: 'DRIVER',
            admin: 'ADMIN',
            referenceCode: 'Reference Code',
        },
    },
    rfidRequests: {
        title: 'RFID Card Requests - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        header: 'RFID Card Requests',
        placeholder: {
            nameEmail: 'Name / Email',
            startDate: 'Start Date',
            endDate: 'End Date',
            publicCardNo: 'Enter The Public Card No',
            enterComments: 'Enter Your Comments',
            status: 'Select Status',
            publicRFIDCardNo: 'Enter the Public RFID Card No.',
            scanReqQR: 'Scan QR code printed on letter',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            save: 'Save',
            cancel: 'Cancel',
            add: 'Add',
            done: 'Done',
            action: 'Action',
            assign: 'Assign',
            downloadPdf: 'Download Requests PDF',
            downloadPdfSelected: 'Download PDF For Selected Requests',
            downloadPendingApprovedPdf: 'Download All Pending & Approved Requests PDF',
        },
        columns: {
            name: 'Name',
            email: 'Email',
            requestedDate: 'Requested Date',
            noofCardReq: 'No of Card Requested',
            noofCardAllocated: 'No of Card Allocated',
            requestStatus: 'Request Status',
            status: 'Status',
            driverStatus: 'Driver Status',
            action: 'Action',
            public_rfid_card_no: 'Card No',
            allocatedBy: 'Allocated By',
            allocatedDate: 'Allocated Date',
            federated_account_type: 'Federated Account Type',
        },
        label: {
            reviewRequest: 'Review Request',
            assignRFID: 'RFID Card',
            processRFIDRequest: 'Process Request',
            noofCardRequested: 'No of Card Requested',
            noofCardAllocated: 'No of Card Allocated',
            approved: 'Approve',
            declined: 'Decline',
            publicCardNo: 'Enter The Public Card No',
            enterComments: 'Enter Your Comments',
            requestStatus: 'Request Status',
            assignRFIDCards: 'Assign RFID Cards',
            publicRFIDCardNo: 'Enter the Public RFID Card No.',
            allocatedRFIDCards: 'Allocated RFID Cards',
            address: 'Address',
            scanReqQR: 'Scan QR code printed on letter',
            name: 'Name',
            requestId: 'Request Id',
            scanHistory: 'Scan History',
        },
        message: {
            requestProcessed: 'Request successfully processed',
        },
        errors: {
            approveReject: 'Please Approve/Decline this request.',
            selectAnyRecord: 'Please select at least one record to download PDF.',
            reqNumTypeError: 'Please enter valid request id',
        },
        pdfText: {
            dear: 'Dear',
            instavolt: ' ##COMPANY_BRAND_NAME##',
            companyNumber: 'Company number',
            line1: 'Thank you for requesting your RFID card via the ##COMPANY_BRAND_NAME## App, please find your card enclosed.',
            line2: 'To activate your card, please follow the steps below:',
            step1: '1. Login to the App',
            step2: "2. In the menu select 'Settings'",
            step3: "3. Click the 'My RFID Cards' option",
            step4: "4. Click the 'Add RFID Card' button",
            step5: "5. Enter the card number printed on the card and press 'Proceed' button",
            step6: '6. Your card is now activated and can be used to start your next charging session',
            line3: 'Did you know you can earn rewards every time you charge? Receive one Volt for each kWh used and once you have accumulated enough Volts, these can be redeemed and used to purchase charging sessions on the network.',
            line4: 'Thanks for charging with us.',
            line5: 'The ##COMPANY_BRAND_NAME## Team',
            line6: 'Delivering world class electric vehicle charging infrastructure to the UK',
        },
    },
    RFIDCardFleets: {
        title: 'RFID cards : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'RFID cards',
        placeholder: {
            name: 'Driver Name / Email / Vehicle Number',
            manufacturer: 'Manufacturer',
            public_card_id: 'Public Card Id',
            status: 'Select Status',
            mifare_uid: 'Mifare UID',
        },
        label: {
            name: 'Name',
            manufacturer: 'Manufacturer',
            part_id: 'Part Id',
            public_card_id: 'Public Card Id',
            private_card_id: 'Private Card Id',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
            enabled: 'Enabled',
            disabled: 'Disabled',
            delete: 'Delete',
            remove: 'Remove Association',
            reinstate: 'Reinstate',
            activated: 'Activated',
            available: 'Available',
            duplicate: 'Duplicate',
        },
        button: {
            search: 'Search',
            cancel: 'Cancel',
            add: 'Add',
            assing: 'Assign RFID Card',
            import: 'Import file',
            save: 'Save',
            edit: 'Edit',
            reset: 'Reset',
            yes: 'Yes',
            no: 'No',
            enabled: 'Enable',
            disabled: 'Disable',
            action: 'Action',
            back: 'Back',
            enable: 'Enable',
            disable: 'Disable',
            getCredentials: 'Get Credentials',
            delete: 'Delete',
            remove: 'Remove Association',
            reinstate: 'Reinstate',
            exportAll: 'Export All',
        },
        message: {
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            deleteConfirmMesage: 'Are you sure you want to delete?',
            removeConfirmMesage: 'Are you sure you want to remove the RFID Card Association to an Account',
            reinstateConfirmMessage: 'Are you sure you want to reinstate the RFID Card?',
        },
        insert: {
            header: 'Manage RFID cards',
            placeholder: {
                manufacturer: 'Manufacturer Name',
                part_id: 'Part Id',
                public_card_id: 'Public card Id',
                private_card_id: 'Private Card Id',
                mifare_uid: 'Mifare UID',
            },
            label: {
                manufacturer: 'Manufacturer',
                part_id: 'Part Id',
                public_card_id: 'Public card Id',
                private_card_id: 'Private Card Id',
                mifare_uid: 'Mifare UID',
            },
            errors: {
                common: 'Something went wrong please try again.',
                name: {
                    valid: 'Enter valid name',
                },
                code: {
                    valid: 'Enter valid Code',
                },
                url: {
                    valid: 'URL must be a valid URL',
                },
            },
        },
        assignCards: {
            header: 'Assign RFID Card',
            label: {
                driver: 'Driver/Vehicle',
            },
            button: {
                yes: 'Assign',
                no: 'Cancel',
            },
            form: {
                driver: 'Driver/Vehicle',
                placeholder: {
                    driver: 'Select Driver/Vehicle',
                },
            },
        },
        disableCards: {
            header: 'Disable',
            header2: 'Are you sure you want to disable?',
            placeholder: {
                comment: 'Enter comment',
            },
            label: {
                comment: 'Comment',
            },
            button: {
                yes: 'Yes',
                no: 'No',
            },
        },
        importCards: {
            header: 'Import RFID Cards',
            placeholder: {
                file: 'Select CSV file',
            },
            label: {
                file: 'CSV File',
            },
            button: {
                yes: 'Import',
                no: 'Cancel',
            },
            errors: {
                common: 'Something went wrong please try again.',
                file: {
                    fileType: "File with extension '.csv' can be uploaded.",
                },
            },
        },
        importCardsDetails: {
            header: 'RFID Cards Import Details',
            label: {
                unSuccessfullImport: 'Following cards cannot be imported',
                successfullImport: 'Following cards are imported successfully',
                failerReason: 'Failure Reason',
                publicCardId: 'Public Card ID',
            },
            message: {
                defualtErrorMessage: 'There is an issue importing the following cards.',
            },
        },
    },
    myProfile: {
        title: 'My Profile : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'My Profile',
        subheader: {
            details: 'Personal Details',
            security: 'Security',
            password: 'Password',
        },
        label: {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            phoneNo: 'Phone No.',
            currentPassword: 'Current Password',
            newPassword: 'New Password',
            confirmPassword: 'Re-Confirm Password',
            mfaAuthentication: '2FA Authentication',
            authentication: 'Authentication',
            securityCode: 'Security Code',
            languagePreference: 'Language Preference',
        },
        placeholder: {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            phoneNo: 'Phone No.',
            currentPassword: 'Current Password',
            newPassword: 'New Password',
            confirmPassword: 'Re-Confirm Password',
            securityCode: 'Security Code',
            languagePreference: 'Language Preference',
        },
        button: {
            save: 'Save',
            cancel: 'Cancel',
            update: 'Update',
            ok: 'OK',
        },
        toast: {
            profileSuccess: 'Profile updated successfully.',
            profileError: 'Profile is not updated. Please try again later.',
            passwordChange: 'Password changed successfully.',
            passwordErr: 'Password is not changed successfully. Please try again later.',
            passwordWrong: 'Current password is Incorrect.',
            securityStop: '2FA Authentication security is stopped.',
            error: 'Something went wrong. Please try again later.',
            securitySetupSuccess: '2FA Authentication is setup successfully.',
            securitySetupError: '2FA Authentication is not setup successfully.Please try again later.',
            securityCodeInvalid: 'Invalid security code.',
        },
        errors: {
            securityCode: {
                match: 'Please enter valid code',
                inValid: 'Please enter 6 digit code',
            },
            password: {
                confirmPasswordMatch: 'New password and re-confirm password does not match.',
            },
        },
    },
    apiCredentials: {
        title: 'API Credentials : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'API Credentials',
        button: {
            generate: 'Generate Token',
            regenerate: 'Regenerate Token',
            yes: 'Yes',
            no: 'No',
        },
        note_no_permission:
            'You do not have rights to get access to the API. Contact ##COMPANY_BRAND_NAME## administrator to get access.',
        note_generte_token:
            'You can generate the token by clicking on "Generate Token" & you can use that token to get access to the API.',
        note: 'You can regenerate the token by clicking on "Regenerate Token" & you can use that token to get access to the API.',
        label: {
            token: 'Token',
            generate: 'Generate Token',
            regenerate: 'Regenerate Token',
        },
        message: {
            regenerateConfirmMesage:
                'Are you sure you want to Regenerate Token? <br/> Once you regenerate the token old token will be invalid and you will not able to access to the API from old one.',
            generateConfirmMesage: 'Are you sure you want to Generate Token?',
        },
    },
    cookiePolicy: {
        text: 'This website uses cookies to enhance the user experience. By using our site, you acknowledge that you have read and understand our ',
        action: 'Cookie Policy',
        iAccept: 'I Accept',
    },
    paymentconfig: {
        title: 'Payment - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        header: 'Payment',
        processingNote: 'Please wait while your transaction is being processed',
        purchaseOrderNote: 'You have a ##PAYMENT_SCHEDULE## billing cycle. Your next billing date will be : ',
        description: 'Payment to ##COMPANY_BRAND_NAME##',
        note: 'Background job will run on every week to clear outstanding bills for EV charging perfomed by Drivers/Vehicles ',
        addReplaceCardNote:
            'Please note when adding a payment card your account will be debited by ##CURRENCY_SYMBOL_WITH_VALUE## which will be credited to your ##COMPANY_BRAND_NAME## wallet balance.',
        label: {
            currentBalance: 'Current Balance',
            closingBalance: 'Closing Balance',
            availableCredit: 'Available Credit',
            unbilledAmount: 'Unbilled Amount',
            cardTitle: 'Name On Card',
            cardNumber: 'Card Number',
            expiry: 'Expiry',
            note: 'Note : ',
            CSC: 'CSC',
            cardSecurityCode: '(Card Security Code)',
            charityDonation: 'Charity Donation',
            roundUp: 'Round Up',
            topUp: 'Top Up',
            expires: 'Expires',
            charity: 'Charity',
        },
        placeholder: {
            cardTitle: 'Name On Card',
            cardNumber: '1234 1234 1234 1234',
            CSC: 'CSC',
            topUpAmount: '00.00',
        },
        button: {
            save: 'Save',
            edit: 'Edit',
            replace: 'Replace',
            back: 'Back',
            payNow: 'Pay Now',
        },
        errors: {
            CSC: {
                min: 'Enter minimum 3 digit code.',
            },
            topupAmount: {
                min: 'Charity Amount must be greater than or equal to 0.1',
            },
            cardNumber: {
                inValid: 'Invalid card number',
            },
            commonError: 'There is an error processing your request, Please try again later.',
            transactionFailed: 'Your transaction has failed, Please try again.',
        },
        message: {
            cardSaved: 'Card details saved successfully',
        },
    },
    refundRequest: {
        title: 'Withdrawal Approvals - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        header: 'Withdrawal Approvals',
        accountInfoNote: 'Account information entered for fulfilling the withdrawal:',
        completeConfirmNote:
            'Only complete this withdrawal request if you have credited the Drivers bank account with value stated. Do you wish to continue?',
        bulkCompleteConfirmNote:
            'Only complete these withdrawal requests if you have credited the Drivers bank account with value stated. Do you wish to continue?',
        declineConfirmNote:
            'Please ensure that you have entered an appropriate reason for declining the request, as this information is passed to the customer.  Do you wish to continue ?',
        bulkDeclineConfirmNote:
            'Please ensure that you have entered an appropriate reason for declining the requests, as this information is passed to the customer.  Do you wish to continue ?',
        label: {
            name: 'Name',
            reviewRequest: 'Review Request',
            driverName: 'Driver Name',
            driverEmail: 'Driver Email',
            requestedDate: 'Requested Date',
            action: 'Action',
            amount: 'Amount',
            refundRequested: 'Withdrawal Requested',
            status: 'Status',
            accountNumber: 'Account Number',
            sortCode: 'Sort Code',
            enterComments: 'Enter Comments',
            pending: 'Pending',
            closed: 'Closed',
            complete: 'Complete',
            decline: 'Decline',
            review_by: 'Reviewed By',
            review_date: 'Reviewed On',
            approvalRequest: 'Aprrove Request',
            processRefundRequest: 'Process Withdrawal Request',
            completeRefundRequest: 'Complete Withdrawal Request',
            bulkCompleteRefundRequest: 'Complete Withdrawal Requests',
            declineRefundRequest: 'Decline Withdrawal Request',
            bulkdeclineRefundRequest: 'Decline Withdrawal Requests',
            export: 'Export Data',
            bulk: 'Bulk',
        },
        button: {
            decline: 'Decline',
            approve: 'Approve',
            reset: 'Reset',
            search: 'Search',
            complete: 'Complete',
            save: 'Save',
            cancel: 'Cancel',
            yes: 'Yes',
            no: 'No',
        },
        placeholder: {
            selectStatus: 'Select Status',
            enterComments: 'Enter Comments',
            name: 'Name/Email',
        },
        errors: {
            status: {
                selectApprovalOrReject: 'Please Complete/Decline this request.',
            },
            selectWithdrawalApprovals: 'Please select withdrawal requests',
        },
    },
    termsAndConditionListing: {
        title: 'Terms & Conditions - ##COMPANY_BRAND_NAME## : Rapid EV Charging UK',
        header: 'Terms & Conditions',
        noteDetails: '*Mandatory must be accepted in order to use/sign up an account.',
        label: {
            iAggreeToTermsCondition: 'I agree to ',
            note: 'Note: ',
            termsAndConditions: 'Terms & Conditions.',
            reviewUpdatedCondition: 'Please review and accept the updated terms & conditions listed below.',
            name: 'Name',
            accepted: 'Accepted',
        },
        button: {
            accept: 'Accept',
            next: 'Next',
            cancel: 'Cancel',
        },
        errors: {
            acceptTermCondition: 'Please accept * mandatory Terms & Conditions to proceed further.',
        },
    },
    adminDashboard: {
        title: 'Home : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Dashboard',
        formtitle: 'Form Validation',
        label: {
            filter: 'Filter',
            reportTags: 'Report Tags',
            driverGroup: 'Driver Groups',
            selectDriverGroup: 'Select Driver Groups',
            selectTags: 'Select Tags',
            dateRange: 'Date Range',
            month: 'Month',
            year: 'Year',
            day: 'Day',
            week: 'Week',
            userSessionTitle: 'Driver Sessions',
            userSessions: 'Driver Sessions',
            totalIncomeTitle: 'Sum of Income',
            income: 'Income',
            transactionTitle: 'Average Transaction',
            transaction: 'Transaction',
            energy: 'Energy',
            energyTitle: 'Sum of Energy (kWh)',
            failedPaymentTitle: 'Number of Failed Payment',
            failedPayment: 'Failed Payment',
            driverCountTitle: 'Driver Counts',
            driver: 'Driver',
            accumulatedVolts: 'Accumulated Volts',
            claimedVolts: 'Claimed Volts ',
            outStandingFailPayment: 'Outstanding Failed Payment',
            outStandingFailedPaymentTitle: 'Outstanding Failed Payments',
            voltsLiability: 'Volts Liability',
            voltsAccumulatedTitle: 'Volts Accumulated',
            volts: 'Volts',
            voltsClaimedTitle: 'Volts Claimed',
            lapsedVolts: 'Lapsed Volts',
            totalNoOfDriverAccount: 'Total Number of Drivers Accounts',
            enabled: 'Enabled',
            disabled: 'Disabled',
            badDebtor: 'Bad Debtor',
            cancelled: 'Cancelled',
            deleted: 'Deleted',
            fake_account: 'Fake Account',
            numberOfReferees: 'Number of Referees',
            numberOfReferrers: 'Number of Referrers',
            referralPayment: 'Referral Payments (Referrer + Referee)',
            referrer: 'Referrer',
            referee: 'Referee',
            moneySpent: 'Money spent by Referees Only',
            referralBonus: 'referral bonus',
            referralPromotion: 'Referral Promotion',
            overnightAutomated: 'Overnight Automated',
            customerManual: 'Customer Manual',
            pending: 'Pending',
            patnerPromoClicksCount: 'Partner Promotions click count ',
            clicksCount: 'Click Count',
            clicksCountMessage: 'Select Single or Multiple options to Show Partner Promotion Click Count',
            individualDrivers: 'Drivers Enabled Accounts',
            organisationDrivers: 'Organisations Enabled Accounts',
            individualAndOrgDriverCount: 'Enabled Accounts: Drivers vs Organisations',
            alerts: 'Alerts',
            alertsCountTitle: 'Alerts Count',
            premiumSubscriptions: 'Premium Subscriptions',
            activeSubscriptions: 'Total Active Premium Subscriptions',
            newSubscriptions: 'New Subscriptions',
            cancelledSubscriptions: 'Cancelled Subscriptions',
            subscriptions: '(Subscriptions)',
        },
        placeholder: {
            patnerPromotions: 'Select one or more partner promotions to show data',
        },
        button: {
            apply: 'Apply',
            clear: 'Clear',
            syncData: 'Sync Data',
        },
    },
    footer: {
        version: 'Version',
        copyRightText: 'All rights reserved',
    },
    cardReader: {
        title: 'Card Readers : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Card Readers',
        manageCardReader: 'Manage Card Reader',
        importHeader: 'Import Card Readers',
        button: {
            import: 'Import',
            add: 'Add',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            edit: 'Edit',
            action: 'Action',
            delete: 'Delete',
            search: 'Search',
            reset: 'Reset',
            disable: 'Disable',
            duplicate: 'Duplicate',
            active: 'Active',
            chargeStation: 'Charge Stations',
            yes: 'Yes',
            no: 'No',
            claimCardReader: 'Claim Unallocated Card Readers',
            claim: 'Claim',
        },
        label: {
            description: 'Description',
            latitude: 'Latitude',
            longitude: 'Longitude',
            serialNumber: 'Serial Number',
            endPoint: 'End Point',
            createdDate: 'Created Date',
            status: 'Status',
            action: 'Action',
            delete: 'Delete',
            csvFile: 'CSV File',
            clickHere: 'Click here',
            downloadTemplate: 'to download template',
            evse_id: 'EVSE ID',
            error: 'Error',
            errorDetail: 'Error Details',
            failureReason: 'Failure Reason',
            id: 'Card Reader ID',
        },
        placeholder: {
            description: 'Description',
            latitude: 'Latitude',
            longitude: 'Longitude',
            serialNumber: 'Serial Number',
            endPoint: 'Override End Point',
            selectStatus: 'Select Status',
        },
        errors: {
            latitude: {
                min: 'Latitude must be between -90.0 and 90.0',
                max: 'Latitude must be between -90.0 and 90.0',
                number: 'Latitude must be a number',
            },
            longitude: {
                min: 'Longitude must be between -180.0 and 180.0',
                max: 'Longitude must be between -180.0 and 180.0',
                number: 'Longitude must be a number',
            },
            serial_number: {
                valid: 'Enter valid serial number',
            },
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            duplicateConfirmMesage: 'Are you sure you want to duplicate?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            activeConfirmMesage: 'Are you sure you want to active?',
        },
        assign: {
            header: 'Charge Stations',
            headerModal: 'Charge Station',
            placeholder: {
                name: 'Enter name',
                address: 'Address',
                tags: 'Select Tags',
            },
            label: {
                add: 'Add',
                address: 'Address',
                city: 'City',
                name: 'Name',
                type: 'Type',
                physical_reference: 'Physical Reference',
                postcode: 'Post Code',
                action: 'Action',
                delete: 'Delete',
            },
            button: {
                delete: 'Delete',
            },
            message: {
                deleteConfirmMesage: 'Are you sure you want to delete?',
            },
        },
    },
    cardScheme: {
        title: 'Card Schemes : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Card Schemes',
        manageCardScheme: 'Manage Card Scheme',
        label: {
            TransIdSeed: 'Transaction Id Seed',
            keybEncrKey: 'KeyB Encryption Key',
            transIdEncrKey: 'Transaction Id Encryption Key',
            emspCode: 'EMSP Code',
            endPoint: 'End Point',
            createdDate: 'Created Date',
            status: 'Status',
            action: 'Action',
            delete: 'Delete',
            enabled: 'Enabled',
            disabled: 'Disabled',
        },
        button: {
            import: 'Import',
            add: 'Add',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            edit: 'Edit',
            action: 'Action',
            delete: 'Delete',
            search: 'Search',
            reset: 'Reset',
            disable: 'Disable',
            enable: 'Enable',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            enableConfirmMesage: 'Are you sure you want to enable?',
        },
        placeholder: {
            emspCode: 'EMSP Code',
            keybEncrKey: 'KeyB Encryption Key',
            transIdEncrKey: 'Transaction Id Encryption Key',
            TransIdSeed: 'Transaction Id Seed',
        },
        errors: {
            emsp_code: {
                valid: 'Enter valid EMSP code',
            },
            transaction_id_seed: {
                valid: 'Enter valid transaction id seed',
                min: 'Transaction id seed can not be less than 0',
                max: 'Maximum limit reached for transaction id seed',
            },
        },
    },
    fleetProfile: {
        orgProfile: 'Organisation Profile',
        message: {
            success: 'Organisation profile updated successfully',
        },
    },
    dataAggregator: {
        title: 'Data Aggregators : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Data Aggregators',
        button: {
            add: 'Add',
            search: 'Search',
            reset: 'Reset',
            enable: 'Enable',
            disable: 'Disable',
            edit: 'Edit',
            yes: 'Yes',
            no: 'No',
            action: 'Action',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            syncDataAggregatorAPIKeys: 'Sync API Keys with Usage Plans',
        },
        placeholder: { name: 'Name', status: 'Select Status' },
        label: {
            enabled: 'Enabled',
            disabled: 'Disabled',
            name: 'Name',
            party_id: 'Party Id',
            country_code: 'Country Code',
            version_url: 'Version URL',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
        },
        message: {
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
        },
        insert: {
            header: 'Manage Data Aggregator',
            errors: {
                common: 'Something went wrong please try again.',
                name: {
                    valid: 'Enter valid Data Aggregator name',
                },
                party_id: {
                    valid: 'Enter valid Party Id',
                },
                country_code: {
                    valid: 'Enter valid Country Code',
                },
                version_url: {
                    url: 'Version URL must be a valid URL',
                },
                token: {
                    valid: 'Enter valid token',
                },
            },
            placeholder: {
                name: 'Name',
                party_id: 'Party Id',
                country_code: 'Country Code',
                version_url: 'Version URL of Data Aggregator',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                emsp: 'EMSP',
                access_group: 'Access Group',
                usagePlan: 'Usage Plan',
            },
            label: {
                name: 'Name',
                party_id: 'Party Id',
                country_code: 'Country Code',
                version_url: 'Version URL',
                emsp: 'EMSP',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                allow_locations_to_be_extracted: 'Only allow locations to be extracted from the EMPS',
                allow_receive_location_update:
                    'Allow to receive PUT(Initial start) and PATCH (Status update) location updates',
                access_group: 'Access Group',
                allow_tariff_extraction: 'Include Tariff',
                usagePlan: 'Usage Plan',
            },
        },
    },
    accessGroups: {
        title: 'Access Groups : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Access Groups',
        manageAccessGroup: 'Manage Access Group',
        label: {
            createdDate: 'Created Date',
            status: 'Status',
            action: 'Action',
            delete: 'Delete',
            enabled: 'Enabled',
            disabled: 'Disabled',
            name: 'Name',
            description: 'Description',
            access_control_type: 'Access Control Type',
            allow_public_access: 'Allow Public Access',
            managed_by_organisation: 'Managed by Organisation',
            override_tariff: 'Override Tariff',
            yes: 'Yes',
            no: 'No',
            access_code: 'Access Code',
            deleted: ' (Deleted)',
        },
        button: {
            enable: 'Enable',
            disable: 'Disable',
            action: 'Action',
            edit: 'Edit',
            delete: 'Delete',
            enabled: 'Enabled',
            disabled: 'Disabled',
            add: 'Add',
            search: 'Search',
            reset: 'Reset',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            deleted: ' (Deleted)',
            chargeStation: 'Charge Locations',
            yes: 'Yes',
            no: 'No',
            drivers: 'Drivers',
        },
        placeholder: {
            name: 'Name',
            selectStatus: 'Select Status',
            allow_public_access: 'Allow Public Access',
            description: 'Description',
            access_control_type: 'Access Control Type',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            enableConfirmMesage: 'Are you sure you want to enable?',
        },
        assign: {
            header: 'Charge Locations',
            headerModal: 'Charge Locations',
            placeholder: {
                name: 'Enter name',
                address: 'Address',
                tags: 'Select Tags',
                postal_code: 'Post Code',
                power_type: 'Select Power Type',
            },
            label: {
                add: 'Add',
                address: 'Address',
                city: 'City',
                name: 'Name',
                type: 'Type',
                physical_reference: 'Physical Reference',
                postcode: 'Post Code',
                action: 'Action',
                delete: 'Delete',
            },
            button: {
                delete: 'Delete',
            },
            message: {
                deleteConfirmMesage: 'Are you sure you want to delete?',
            },
        },
        driverAssign: {
            header: 'Drivers',
            headerModal: 'Drivers',
            placeholder: { email: 'Email', status: 'Status' },
        },
        errors: {
            name: {
                valid: 'Enter valid Name',
            },
        },
    },
    accessGroupRequests: {
        title: 'Access Group Requests : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Access Group Requests',
        columns: {
            name: 'Name',
            email: 'Email',
            federated_account_type: 'Federated Account Type',
            requested_access_group: 'Requested Access Group',
            requested_date: 'Requested Date',
            driver_status: 'Driver Status',
            request_status: 'Request Status',
            action: 'Action',
        },
        button: { action: 'Action', search: 'Search', reset: 'Reset', save: 'Save', cancel: 'Cancel' },
        label: {
            review_request: 'Review Request',
            requested_access_group: 'Requested Access Group:',
            approve: 'Approve',
            decline: 'Decline',
            enterComments: 'Comments',
        },
        placeholder: {
            nameEmail: 'Name / Email',
            startDate: 'Start Date',
            endDate: 'End Date',
            status: 'Select Status',
            enterComments: 'Enter Your Comments',
        },
        errors: {
            approveReject: 'Please Approve/Decline this request.',
        },
    },
    payByWeb: {
        title: 'Pay By Web : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Pay By Web',
        columns: {
            evse_id: 'EVSE ID',
            status: 'Status',
            physical_reference: 'Physical Reference',
            location_name: 'Location Name',
            location_address: 'Location Address',
            location_city: 'Location City',
            location_postal_code: 'Location Postal Code',
            pay_by_web_active: 'Pay By Web',
            action: 'Action',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            enablePayByWeb: 'Enable Pay By Web',
            disabledPayByWeb: 'Disable Pay By Web',
            submit: 'Submit',
            cancel: 'Cancel',
        },
        label: {
            enabled: 'Enable',
            disabled: 'Disable',
            manageUniqueCode: 'Manage Unique Code',
            uniqueCode: 'Unique Code',
        },
        message: {
            enableConfirmMesage: 'Are you sure you want to enable pay by web for selected stations?',
            disableConfirmMesage: 'Are you sure you want to disable pay by web for selected stations?',
        },
        placeholder: {
            evse_id: 'EVSE ID',
            status: 'Select Status',
            physical_reference: 'Physical Reference',
            location_name: 'Location Name',
            location_address: 'Location Address',
        },
        errors: {
            unique_code: {
                valid: 'Enter valid unique code',
            },
        },
    },
    driverDebt: {
        title: 'Driver Debt : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Driver Debt',
        button: {
            download: 'Download',
            strikeOneLetter: 'Strike One Letter',
            strikeTwoLetter: 'Strike Two Letter',
            generateStrikeOneLetters: 'Generate Strike One Letters',
            generateStrikeTwoLetters: 'Generate Strike Two Letters',
            runHistory: 'Generate Strike Letters - Run History',
            pastLetters: 'Past Letters',
            regenerateLetters: 'Regenerate Letters',
            refreshPastLetters: 'Refresh Past Letters',
        },
        label: {
            pastLetters: 'Past Letters',
            inProgress: '(in progress)',
            noDataFound: 'No Data Found.',
            dynamicFields: 'Dynamic Fields',
            clickToCopy: '(click to copy notation)',
            driverName: 'Driver Name',
            driverDebt: 'Driver Debt',
            debtAge: 'Debt Age',
            driverEmail: 'Driver Email',
            driverAddress: 'Driver Address',
            date: 'Date',
            clickToCopyTooltip: 'Click to Copy',
            regenerate: 'Regenerate',
            regenerateLetters: 'Regenerate Letters',
            letterTemplate: 'Letter Template',
            cancel: 'Cancel',
            reportGenerationInProgress: '(Report generation in progress)',
            copyDriverIds: 'Click to copy driver ids',
        },
        columns: {
            run: 'Run No.',
            driverIDs: 'Driver IDs Eligible at This Point of Run',
            runTimestamp: 'Run Timestamp',
            strikeType: 'Strike Type',
            initiatedByUser: 'User Who Initiated the Run',
            regenerate: 'Regenerate',
            action: 'Action',
            relatedRun: 'Related Run No.',
            date: 'Date',
            file: 'File',
            templateUsed: 'Template Used',
            generatedBy: 'Generated By',
        },
        placeholder: {
            strikeOneLetter: 'Select Strike One Letter',
            strikeTwoLetter: 'Select Strike Two Letter',
        },
    },
    fleetAccessGroups: {
        title: 'Access Group Requests : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
    },
    emailLogs: {
        title: 'Email Logs : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Email Logs',
        columns: {
            recipient: 'Recipient',
            subject: 'Subject',
            deliveryStatus: 'Delivery Status',
            errorMessage: 'Error Message',
            createdDate: 'Created Date',
        },
        label: {
            viewError: 'View Error',
        },
        placeholder: {
            recipient: 'Recipient',
            subject: 'Subject',
            deliveryStatus: 'Delivery status',
            errorMessage: 'Error Message',
            startDate: 'Start Date',
            endDate: 'End Date',
        },
    },
    alerts: {
        title: 'OCPI Error Logs : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'OCPI Error Logs',
        columns: {
            api: 'url',
            api_call_type: 'API Call Type',
            api_request_type: 'Request Type',
            response_code: 'Response Code',
            error_message: 'Error Message',
            alert_type: 'Alert Type',
            created_date: 'Created Date',
            request_body: 'Request Body',
            response_body: 'Response Body',
        },
        placeholder: {
            api: 'url',
            alert_type: 'Alert Type',
            startDate: 'Start Date',
            endDate: 'End Date',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
        },
        label: {
            viewDetails: 'View Details',
            errorLogDetails: 'OCPI Error Log Details',
        },
    },
    SubscriptionSetting: {
        title: 'Premium Subscriptions : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Premium Subscriptions',
        manageSubscription: 'Manage Premium Subscription',
        label: {
            subscription_type: 'Subscription Type',
            subscription_amount: 'Subscription Amount',
            free_subscription_duration: 'Free Subscription Duration',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
            enabled: 'Enable',
            disabled: 'Disable',
            maximum_routing_call: 'Maximum Routing Calls (Per Month)',
            additional_volts_per_kwh: 'Additional Volt(s) Reward / kWh',
            name: 'Name',
            description: 'Description',
            subscriptionImage: 'Premium Subscription Image',
            exportSubscribersList: 'Export Subscribers List',
            downloadSubscribersList: 'Download Subscribers List',
        },
        placeholder: {
            subscription_amount: 'Subscription Amount',
            free_subscription_duration: 'Free Subscription Duration (Days)',
            maximum_routing_call: 'Maximum Routing Calls',
            name: 'Name',
            status: 'Select Status',
            subscriptionType: 'Select Subscription Type',
            subscriptionImage: 'Select Premium Subscription Image',
        },
        button: {
            action: 'Action',
            disable: 'Disable',
            enable: 'Enable',
            edit: 'Edit',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            enableDisable: 'Enable / Disable Subscription',
            add: 'Add',
            search: 'Search',
            reset: 'Reset',
        },
        errors: {
            amount: {
                moreThan: 'Amount must be greater than 1',
                lessThan: 'Amount must be less than 100',
                number: 'Amount must be a number',
            },
            duration: {
                moreThan: 'Duration must be greater than 1',
                lessThan: 'Duration must be less than 180',
            },
            maxRoutingCall: {
                moreThan: 'Maximum routing calls value must be greater than 1',
                lessThan: 'Maximum routing calls value must be less than 1000',
            },
            additionalVolts: {
                lessThan: 'Value must be less than or equal to 5',
                number: 'Value must be a number',
            },
        },
        message: {
            enableFromConfig:
                "To Enable a Premium Subscription, please first set 'Enable Premium Subscription' to 'True' in Settings > Configurations",
            disableConfirmMessage:
                'Warning: Disabling the Premium Subscription will result in the cancellation of all the associated Driver account auto-renewals. Are you sure you want to disable?',
            enableConfirmMessage: 'Are you sure you want to enable?',
        },
    },
    advertisingDevices: {
        title: 'Advertising Devices : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Advertising Devices',
        label: {
            enabled: 'Enabled',
            disabled: 'Disabled',
            device_name: 'Name',
            device_id: 'Device ID',
            postal_code: 'Postal Code',
            charge_station: 'Charge Station',
            screen_size: 'Screen Size',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
            delete: 'Delete',
            operational: 'Operational',
        },
        button: {
            action: 'Action',
            edit: 'Edit',
            delete: 'Delete',
            enabled: 'Enable',
            disabled: 'Disable',
            add: 'Add',
            reset: 'Reset',
            search: 'Search',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            assignVideos: 'Assign Videos',
            yes: 'Yes',
            no: 'No',
            regenerateS3File: 'Regenerate S3 File',
            mediaTerminalLogs: 'Media Terminal Logs',
        },
        placeholder: {
            device_name: 'Device Name',
            postal_code: 'Postal Code',
            charge_station: 'Charge Station',
            selectStatus: 'Select Status',
            screen_size: 'Screen Size',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
        },
        insert: {
            header: 'Manage Advertising Device',

            placeholder: {
                device_name: 'Device Name',
                device_id: 'Device Id',
                charge_station: 'Charge Station',
                screen_size: 'Screen Size',
            },
            label: {
                device_name: 'Device Name',
                device_id: 'Device Id',
                charge_station: 'Charge Station',
                screen_size: 'Screen Size',
            },
            errors: {
                common: 'Something went wrong please try again.',
                name: {
                    valid: 'Enter valid name',
                },
                device_id: {
                    valid: 'Enter valid Device ID',
                    min: 'Device ID must be at least 6 characters',
                },
            },
        },
        assignVideos: {
            header: 'Videos',
            headerModal: 'Videos',
            label: {
                action: 'Action',
                delete: 'Delete',
            },
            placeholder: {
                file_name: 'File Name',
                description: 'Description',
            },
            message: {
                deleteConfirmMesage: 'Are you sure you want to delete?',
            },
        },
    },
    advertisingVideos: {
        title: 'Advertising Videos : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Advertising Videos',
        label: {
            file_name: 'File Name',
            description: 'Description',
            operational_start_date: 'Operational Start Date',
            operational_end_date: 'Operational End Date',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
            delete: 'Delete',
            reviewVideo: 'Review Video',
            approve: 'Approve',
            reject: 'Reject',
            videoUpload: 'Video',
            comments: 'Comments',
        },
        button: {
            action: 'Action',
            edit: 'Edit',
            delete: 'Delete',
            enabled: 'Enable',
            disabled: 'Disable',
            add: 'Add',
            reset: 'Reset',
            search: 'Search',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
            reviewVideo: 'Review Video',
            downloadVideo: 'Download Video',
            assignDevice: 'Assign Devices',
        },
        placeholder: {
            file_name: 'File Name',
            description: 'Description',
            start_date: 'Operational Start Date',
            end_date: 'Operational End Date',
            selectStatus: 'Select Status',
            videoUpload: 'Video',
            enterComments: 'Enter your comments',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
        },
        insert: {
            header: 'Manage Advertising Video',

            placeholder: {
                description: 'Description',
                operational_start_date: 'Operational Start Date',
                operational_end_date: 'Operational End Date',
            },
            label: {
                description: 'Description',
                operational_start_date: 'Operational Start Date',
                operational_end_date: 'Operational End Date',
            },
        },
        errors: {
            status: {
                message: {
                    selectApprovalOrReject: 'Please Approve/Reject this request.',
                },
            },
            name: {
                valid: 'Enter valid name',
            },
            file_name: {
                fileType: "File with extension '.mp4', '.flv', '.wmv', '.mpeg', '.avi', '.3gp' can be uploaded",
                uploadError: 'Error Uploading Video file',
                required: 'Video file is required',
                fileNameLength: 'Maximum 15 characters are allowed for the file name',
            },
            file_size: 'Maximum file upload size limit is',
        },
        assignDevices: {
            header: 'Devices',
            headerModal: 'Devices',
            label: {
                action: 'Action',
                delete: 'Delete',
            },
            placeholder: {
                device_name: 'Device Name',
                device_id: 'Device ID',
                status: 'Status',
            },
            message: {
                deleteConfirmMesage: 'Are you sure you want to delete?',
            },
        },
    },
    advertisingCredentials: {
        title: 'Advertising Credentials : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Advertising Credentials',
        manageCredentials: 'Manage Advertising Credentials',
        label: {
            bucket_name: 'Bucket Name',
            region_name: 'Region Name',
            download_access_key: 'Download Access Key',
            download_secret_key: 'Download Secret Key',
            upload_access_key: 'Upload Access Key',
            upload_secret_key: 'Upload Secret Key',
            download_info_object_name: 'Download Info Object Name',
            upload_path: 'Upload Path',
            dialog_password: 'Dialog Password',
            expect_bucket_name: 'Expect Bucket Name',
            expect_region_name: 'Expect Region Name',
            expect_download_access_key: 'Expect Download Access Key',
            expect_download_secret_key: 'Expect Download Secret Key',
            version_code: 'Version Code',
            download_url: 'Download URL',
            prompt: 'Prompt',
            remarks: 'Remarks',
            modified_by: 'Modified By',
            modified_date: 'Modified Date',
            status: 'Status',
            action: 'Action',
            enabled: 'Enable',
            disabled: 'Disable',
        },
        button: {
            action: 'Action',
            disable: 'Disable',
            enable: 'Enable',
            edit: 'Edit',
            back: 'Back',
            save: 'Save',
            cancel: 'Cancel',
        },
    },
    organisationInvoices: {
        title: 'Organisation Invoices : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Organisation Invoices',
        label: {
            name: 'Organisation',
            invoice_id: 'Invoice ID',
            invoice_value: 'Invoice Value',
            invoice_date: 'Invoice Date',
            action: 'Action',
            undo: 'Undo',
            undoPayment: 'Undo Payment',
            disputed: 'Disputed',
            adjustAmount: 'Adjust Invoice Value ',
            paid_value: 'Paid Value',
            outstanding: 'Outstanding',
            status: 'Status',
            comments: 'Comments',
            original_value: 'Original Value',
        },
        placeholder: {
            name: 'Name',
            start_date: 'Start Date',
            end_date: 'End Date',
            status: 'Status',
            organisation: 'Select Organisation',
        },
        button: {
            search: 'Search',
            reset: 'Reset',
            action: 'Action',
            pay: 'Pay',
            partPay: 'Part Pay',
            undo: 'Undo',
            disputed: 'Disputed',
            adjustValue: 'Adjust Invoice Value',
        },
        errors: {
            amount: {
                moreThan: 'Amount must be greater than 0',
                maxValue: 'Maximum value reached for amount',
                notZero: 'Amount must be greater/less than 0',
                minValue: 'Minimum value reached for amount',
                number: 'Amount must be a number',
            },
            organisation: {
                required: 'Please select organisation',
            },
        },
        message: {
            undoConfirmMessage:
                "Are you sure you want to remove paid value and set status to 'Outstanding' for this invoice?",
            disputedConfirmMessage: "Are you sure you want set status to 'Disputed' for this invoice?",
        },
        payModal: {
            header: 'Pay',
            partPayHeader: 'Part Pay',
            label: {
                amount: 'Amount',
                date_paid: 'Date Paid',
                comments: 'Comments',
            },
            placeholder: {
                amount: 'Enter Amount',
                date_paid: 'Enter Date Paid',
                comments: 'Enter Comments',
            },
            button: {
                accept: 'Accept',
                send_for_approval: 'Send For Approval',
                cancel: 'Cancel',
                submit: 'Submit',
            },
        },
    },
    mediaTerminalLogs: {
        title: 'Media Terminal Logs : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Media Terminal Logs',
        label: {
            file_name: 'File Name',
            date_played: 'Date Played',
            play_time: 'Play Time',
            start_time: 'Start Time',
        },
        placeholder: {
            fileName: 'File Name',
            startDate: 'Start Date',
            endDate: 'End Date',
        },
    },
    fleetDriverSpendHistory: {
        title: 'Spend Limit History: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Spend Limit History',
        label: {
            enabled: 'Enabled',
            disabled: 'Disabled',
            name: 'Driver Name',
            email: 'Driver Email',
            type: 'Threshold Type',
            spend_limit_exceed_date: 'Spend Limit Exceed Date',
            status: 'Driver Status',
            action: 'Action',
            export: 'Export',
            onStop: 'On Stop',
            cancelOnStop: 'Cancel On Stop',
        },
        button: {
            disable: 'Disable',
            enable: 'Enable',
            search: 'Search',
            reset: 'Reset',
            yes: 'Yes',
            no: 'No',
            back: 'Back',
        },
        placeholder: {
            name: 'Driver Name',
            email: 'Driver Email',
            status: 'Select Driver Status',
            dateFrom: 'Limit Exceed Date From',
            dateTo: 'Limit Exceed Date To',
            type: 'Select Threshold Type',
        },
        message: {
            noDataToExport: 'There is no data to export.',
            cancelOnStopConfirmation: 'Are you sure you want to cancel on stop for this driver?',
        },
    },
    driverDebtorLetters: {
        title: 'Driver Debtor Letters: ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Driver Debtor Letters',
        manageDriverDebtorLetter: 'Manage Driver Debtor Letter',
        label: {
            reportType: 'Report Type',
            defaultLetter: 'Default Debtor Letter Template',
            content: 'Content',
            enabled: 'Enabled',
            disabled: 'Disabled',
            created_date: 'Created Date',
            status: 'Status',
            action: 'Action',
            delete: 'Delete',
            dynamicFields: 'Dynamic Fields',
            copyNotation: '(Click to copy notation)',
            clickToCopy: 'Click to Copy',
            driverName: ' • Driver Name',
            driverDebt: '• Driver Debt',
            debtAge: '• Debt Age',
            driverEmail: '• Driver Email',
            driverAddress: '• Driver Address',
            date: '• Date',
            uniqueReference: '• Unique Reference',
            useStandardTemplate: 'Use Standard Template',
        },
        column: {
            defaultLetter: 'Default Letter',
        },
        button: {
            setDefaultLetter: 'Set as default',
            enable: 'Enable',
            disable: 'Disable',
            edit: 'Edit',
            delete: 'Delete',
            createDuplicate: 'Create Duplicate',
            save: 'Save',
            cancel: 'Cancel',
            preview: 'Preview',
        },
        message: {
            setDefaultConfirmMesage: 'Are you sure you want to set this Debtor Letter as default?',
            enableConfirmMesage: 'Are you sure you want to enable?',
            disableConfirmMesage: 'Are you sure you want to disable?',
            deleteConfirmMesage: 'Are you sure you want to delete?',
        },
        error: {
            emptyContent: 'Please provide content to preview Letter Template',
            common: 'There is an error processing your request, Please try again later.',
            supportedDynamicField1: 'These dynamic fields',
            supportedDynamicField2: 'are only supported for debtor letter.',
        },
    },
    driverSubscriptions: {
        title: 'Driver Premium Subscriptions : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        header: 'Premium Subscriptions',
        label: {
            subscriptionType: 'Subscription Type',
            subscriptionStartDate: 'Subscription Start Date',
            subscriptionStatus: 'Subscription Status',
            renewalOrExpiryDate: 'Renewal / Expiry Date',
            voltsCredited: 'Volts Credited',
            journeysPlanned: 'Journeys Planned',
            active: 'Active',
            cancelled: 'Cancelled',
            action: 'Action',
            cancel: 'Cancel',
            cancelSubscription: 'Cancel Subscription',
            terminate: 'Terminate',
            terminateSubscription: 'Terminate Subscription',
            freeTrial: 'Free Trial',
            name: 'Name',
            promotion: 'Promotion',
        },
        message: {
            cancelConfirmMessage:
                'Are you sure you want cancel subscription for this user? This will cancel next auto renewal of subscription.',
            terminateConfirmMessage:
                'Are you sure you want to terminate subscription for this user? This will cancel next auto renewal and stop all benefits of this subscription immediately.',
            terminateConfirmMessageWithoutRenew:
                'Are you sure you want to terminate subscription for this user? This will stop all benefits of this subscription immediately.',
        },
    },
    advertisingDropDownDefaultmessage: 'Enter minimum 3 characters of locations to display stations list',
    rfidcardDropDownDefaultMessage: 'Enter minimum 3 characters to display drivers/vehicles list',
    chargeStationMapDropDownDefaultMessage: 'Enter minimum 3 characters of charge station to display charge stations',
    startChargePageDropDownDefaultMessage: 'Enter  characters of locations to display locations list',
    groupGridDropDownDefaultMessage: 'Enter minimum 3 characters to display drivers/vehicles list',
    organisationdashBoardDefaultMessage: 'Enter minimum 3 characters to display drivers/vehicles list',
    tariffDropDownDefaultMessage: 'Enter minimum 3 characters of tariff to display tariff list',
    rfidAssigncardDefaultDropDownMessage: 'Enter minimum 3 characters of driver email to display drivers list',
    limitExceedAddressError: 'Unable to find the address at this moment',
    continueTypingSearch: 'Continue typing to rectify search',
    noFileChosen: 'No file chosen',
    ChooseFile: 'Choose File',
    noOptions: 'No Options',
    requiredField: 'File is a required field',
    removeImage: 'Remove Image',
    help: 'Help',
    editor: {
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        strikeThrough: 'Strikethrough',
        monospace: 'Monospace',
        superscript: 'Superscript',
        subscript: 'Subscript',
        blockType: 'Block Type',
        fontSize: 'Font Size',
        font: 'Font',
        unordered: 'Unordered',
        ordered: 'Ordered',
        indent: 'Indent',
        outdent: 'Outdent',
        left: 'Left',
        right: 'Right',
        center: 'Center',
        justify: 'Justify',
        colorPicker: 'Color Picker',
        link: 'Link',
        unlink: 'Unlink',
        embedded: 'Embedded',
        emoji: 'Emoji',
        remove: 'Remove',
        undo: 'Undo',
        redo: 'Redo',
        image: 'Image',
    },
    map: {
        zoomIn: 'Zoom In',
        zoomOut: 'Zoom Out',
    },
    InstaVolt: '##COMPANY_BRAND_NAME##',
    apply: 'Apply',
    cancel: 'Cancel',
    noDataFound: 'Sorry! no data found',
    globalService: {
        title: 'Global Service registration : ##COMPANY_BRAND_NAME## - eMobility Service Platform',
        status: {
            pending:
                "To communicate with the global services, Please enter the information below. via pressing 'Register' button you can setup the communication.",
            registered:
                "EMSP Platform can communicate right now with the global services. If there are some issue you are facing in communicating, Please enter the information below and click on 'Re-Register' button.",
        },
        insert: {
            url: 'URL',
            handshakeToken: 'Handshake Token',
        },
        placeholder: {
            url: 'URL',
            handshakeToken: 'Handshake Token',
        },
        label: {
            note: 'Note',
            noteValue:
                "'Handshake token' needs to enter every time when one setup the communication with global services. To identify the 'Handshake token', Please contact system admin.",
            rfidSync: 'RFID Sync',
        },
        button: {
            register: 'Register',
            reRegister: 'Re-Register',
        },
        error: {
            errorWhileCreatingGlobalService: 'Error while creating global service.',
            errorWhileUpdatingGlobalService: 'Error while updating global service.',
        },
        endpointsTable: {
            header: 'Global Service Endpoint',
            column: {
                identifer: 'Identifer',
                httpMethod: 'Http Method',
                url: 'Url',
            },
        },
    },
    price_breakdown_details: {
        detailed_breakup: 'Detailed Breakup',
        total_cost: 'Total Cost',
        conversion_rate: 'Conversion Rate',
        totalNetCost: 'Total Net Cost',
        total_parking_cost: 'Total Parking Cost',
        total_energy_cost: 'Total Energy Cost',
        total_fixed_cost: 'Total Fixed Cost',
        total_time_cost: 'Total Charging Time Cost',
    },
    SubscriptionImages: {
        title: 'Premium Subscription Images',
        manageSubscriptionImage: 'Manage Premium Subscription Image',
        label: {
            name: 'Name',
            description: 'Description',
            action: 'Action',
            delete: 'Delete',
            image: 'Image',
            language: 'Language',
        },
        button: {
            edit: 'Edit',
            search: 'Search',
            reset: 'Reset',
            add: 'Add',
        },
        message: {
            deleteConfirmMesage: 'Are you sure you want to delete?',
        },
        errors: {
            insertEnglishLanguageImage: 'Please upload image for english language',
            required: 'Image is required.',
        },
    },
    driverPaymentCards: {
        title: 'Driver Payment Cards : InstaVolt - eMobility Service Platform',
        header: 'Payment Cards',
        label: {},
    },
};
